
; +(function () {
  // collection product
  function Collection(ele) {
    this.$ele = $(ele)
    this.initVariants()
    if (this.variantData) {
      this.initEvent()
    }
    if (this.$ele.data('bundleInfo')) {
      this.initBundleEvent()
    }
  }

  Collection.prototype.initVariants = function () {
    var jsonEle = this.$ele.find('.variant-json')
    if (jsonEle.length == 0) {
      return
    }
    this.variantData = JSON.parse(jsonEle.text())

    // //=============  To Display compare_at_price of Ca v1=========================
    // if(jsonEle[0]?.dataset)this.variantData.forEach(item => {
    //   let compareAtPrice = jsonEle[0].dataset[`priceV-${item.id}`]
    //   if (compareAtPrice && parseInt(compareAtPrice) >= item.price) {
    //     item.compare_at_price = parseInt(compareAtPrice)
    //   }
    // })

    //=============  To Display compare_at_price of Ca v2=========================
    this.variantData = formatVariantDataByDiscountPriceData(this.variantData)
    this.recommend = this.$ele.data('recommend')


    var discountEle = $(document.body).children('.discount-json')
    if (discountEle.length > 0) {
      this.discountData = JSON.parse(discountEle.text())
    }
    if (this.$ele.find('select.grid-product-variant-input').length) {
      const initialOptions = {}
      this.$ele.find('select.grid-product-variant-input').each((i, e) => {
        var name = $(e).data('index')
        var options = $(e).find('option').map((i, a) => a.value).get()
        initialOptions[name] = options
      })
      let availableVariants = this.variantData
      for (var key in initialOptions) {
        const availableOptionVariants = []
        for (var variant of availableVariants) {
          if (initialOptions[key].includes(variant[key])) {
            availableOptionVariants.push(variant)
          }
        }
        availableVariants = availableOptionVariants
      }
      this.variantData = availableVariants
    }

    this.getOptionValues()
    this.updateAvailableOptions()
    this.updateImage()
  }

  Collection.prototype.initBundleEvent = function () {
    this.$ele.on('change', '.grid-product-variant-input', this.onBundleSelectChange.bind(this))
  }

  Collection.prototype.initEvent = function () {
    this.$ele.on('change', '.grid-product-variant-input', this.onSelectChange.bind(this))
    // this.updateDiscount() // init discount information when searching by sku
    // this.updatePrice()
    if (!theme.isMobile()) {
      if (this.$ele.find('.grid-product__hover-image').length) {
        this.$ele.find('.grid-product__image-mask').on('mouseenter', () => {
          this.$ele.find('.grid-product__hover-image').addClass('is-active')
        })
        this.$ele.find('.grid-product__image-mask').on('mouseleave', () => {
          this.$ele.find('.grid-product__hover-image').removeClass('is-active')
        })
      }
      if (this.$ele.find('.grid-product__hover-video').length) {
        this.$ele.find('.grid-product__image-mask').on('mouseenter touchstart', () => {
          this.$ele.find('.grid-product__hover-video video').get(0).play()
        })
        this.$ele.find('.grid-product__image-mask').on('mouseleave touchend', () => {
          this.$ele.find('.grid-product__hover-video video').get(0).pause()
        })
      }
      this.$ele.on('mouseenter', '.color-swatch__label', this.onColorImageEnter.bind(this))
      this.$ele.on('mouseleave', '.color-swatch__label', () => {
        this.updateImage()
      })
      this.$ele.on('mouseenter', '.grid-product-variant-color .vego-select-item', this.onSelectorColorImageEnter.bind(this))
      this.$ele.on('mouseleave', '.grid-product-variant-color .vego-select-item', () => {
        this.updateImage()
      })
    }
    this.updatePreOrder()
    this.updateEst()
    this.judgeSubscription()
  }

  Collection.prototype.onSelectorColorImageEnter = function (e) {
    e.stopPropagation()
    var v = $(e.currentTarget).data('value')
    var index = $(e.currentTarget).closest('.grid-product-variant-color').data('index')
    this.matchImage(index, v)
  }

  Collection.prototype.onColorImageEnter = function (e) {
    e.stopPropagation()
    var v = $(e.currentTarget).siblings('input').val()
    var index = $(e.currentTarget).siblings('input').data('index')
    this.matchImage(index, v)
  }

  Collection.prototype.matchImage = function (index, value) {
    var selected = []
    for (var i = 1; i < 4; i++) {
      if (index !== 'option' + i) {
        value = this.current['option' + i]
      }
      selected.push({
        index: 'option' + i,
        value: value
      })
    }
    var selectedVariant
    for (var i = 0; i < this.variantData.length; i++) {
      var data = this.variantData[i]
      var find = true
      for (var j = 0; j < selected.length; j++) {
        var e = selected[j]
        if (data[e.index] != e.value) {
          find = false
        }
      }
      if (find) {
        selectedVariant = data
        break
      }
    }
    this.updateImage(selectedVariant.id)
  }

  Collection.prototype.getOptionValues = function () {
    var _this = this
    if (!this.variantData) {
      return
    }
    var selected = []
    this.selectMap = {}
    this.$ele.find('.grid-product-variant-input:enabled').each(function () {
      if ($(this).attr('type') == 'radio') {
        if ($(this).prop('checked')) {
          selected.push({
            value: $(this).val(),
            index: $(this).data('index'),
          })
          _this.selectMap[$(this).attr('name')] = $(this).val()
        }
      } else if ($(this).data('select') == 'variant') {
        selected.push({
          value: $(this).val()
        })
      } else {
        selected.push({
          value: $(this).val(),
          index: $(this).data('index'),
        })
        _this.selectMap[$(this).attr('name')] = $(this).val()
      }
    })
    for (var i = 0; i < _this.variantData.length; i++) {
      var data = _this.variantData[i]
      var find = true
      for (var j = 0; j < selected.length; j++) {
        var e = selected[j]
        if (data[e.index] != e.value) {
          find = false
        }
        if (data.id == e.value) {
          this.current = data
          return
        }
      }
      if (find) {
        this.current = data
        break
      }
    }
  }

  Collection.prototype.onBundleSelectChange = function (e) {
    // this.$ele.find('.product-single__variants').val(this.current.id)
    // this.$ele.find('.product-single__variants').trigger('change')
    var bundle = this.$ele.data('bundleInfo')
    var cartProduct = bundle.products[0]
    var inCartPrice = cartProduct.price * cartProduct.bundleQuantity
    var product = bundle.products[1]
    var selectVaraiant
    var _this = this
    var selectOptions = []
    product.options.forEach((option, i) => {
      var $select = _this.$ele.find('.grid-product-variant-input[name="' + option.name + '"]');
      if ($select.length) {
        selectOptions[i] = $select.val()
      }
    })
    if (selectOptions.length) {
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i]
        var match = true
        for (var j = 0; j < selectOptions.length; j++) {
          var option = selectOptions[j]
          if (variant['option' + (j + 1)] !== option) {
            match = false
          }
        }
        if (match) {
          selectVaraiant = variant
          break
        }
      }
    }
    if (selectVaraiant) {
      this.$ele.find('.product-single__variants').val(selectVaraiant.id)
      this.$ele.find('.product-single__variants').trigger('change')
      this.$ele
        .find('.add-to-cart span:nth(0)').text('Add ' + theme.Currency.formatMoney(
          inCartPrice + selectVaraiant.price * 100 * product.quantity - bundle.bundleDiscount * 100,
          theme.settings.moneyFormat
        ))
      this.$ele
        .find('.add-to-cart span:nth(1)').text('Save ' + theme.Currency.formatMoney(
          selectVaraiant.bundleDiscount * 100,
          theme.settings.moneyFormat
        ))
    }
  }
  /**
   * # -------------------------------- composter subscription action --------------------------------
   * ## special for composter in list page
   * 1. update subscriptions when updating size. for example: 1 bag to Quarterly Subscription, 2 bags to Semi-Annual Subscription
   * @param {*} e       current selected option element
   */
  Collection.prototype.judgeSubscription = function (e) {
    if (!e) {
      e = { target: this.$ele[0].querySelector('[name="Size"]') };
    }
    if (e.target?.name == 'Size' && e.target?.closest('form').querySelector('[name="Subscription"]')) {
      let form = e.target.closest('form');
      if (['3-month supplies', '1 bag'].includes(e.target.value.toLowerCase())) {
        $(form).find('[data-value="Quarterly Subscription"]').show()
        if ($(form).find('[data-value="Semi-Annual Subscription"].active').length) {
          $(form).find('[data-value="Quarterly Subscription"]').click();
        }
        $(form).find('[data-value="Semi-Annual Subscription"]').hide()

      } else if (['half-year supplies', '2 bags'].includes(e.target.value.toLowerCase())) {
        $(form).find('[data-value="Quarterly Subscription"]').hide()
        $(form).find('[data-value="Semi-Annual Subscription"]').show()
        if ($(form).find('[data-value="Quarterly Subscription"].active').length) {
          $(form).find('[data-value="Semi-Annual Subscription"]').click();
        }
      }
    }

  },

    Collection.prototype.onSelectChange = function (e) {
      this.judgeSubscription(e)
      this.getOptionValues()
      this.updateAvailableOptions()
      this.updateImage()
      this.$ele.find('.product-single__variants').val(this.current.id)
      this.$ele.find('.product-single__variants').trigger('change')
      this.updateColor()
      this.updatePrice()
      this.updatePreOrder()
      this.updateEst()
      this.updateDiscount()
      this.updateAvailable()
      var scrollY = window.scrollY
      window.scrollTo(0, scrollY)
      if (this.recommend) {
        this.updateLink()
      }
    }
  Collection.prototype.updateLink = function () {
    if (this.current.available) {
      var link = this.$ele.find('.grid-product__link').attr('href')
      var urls = link.split('?')
      if (urls.length) {
        var base = urls[0]
        this.$ele.find('.grid-product__link').attr('href', base + '?variant=' + this.current.id + '&recommend=' + this.recommend)
      }
    }
  }
  Collection.prototype.updateAvailable = function () {
    if (this.current.available) {
      this.$ele.find('.add-to-cart').removeClass('disabled').prop('disabled', false)
    } else {
      this.$ele.find('.add-to-cart').addClass('disabled').prop('disabled', true)
    }
  }

  Collection.prototype.updateAvailableOptions = function () {
    var length = 0;
    if (!this.current) {
      return
    }
    while (length < 4) {
      if (this.current['option' + (length + 1)] == null) {
        break
      }
      length++
    }
    const vs = []
    for (var i = 0; i < length; i++) {
      if (!vs[i]) {
        vs[i] = []
      }
      for (var variantData of this.variantData) {
        var match = true
        for (var j = 0; j < length; j++) {
          var optionIndex = 'option' + (j + 1)
          if (i !== j && (variantData[optionIndex] != this.current[optionIndex])) {
            match = false
          }
        }
        if (match && !vs[i].includes(variantData['option' + (i + 1)])) {
          vs[i].push(variantData['option' + (i + 1)])
        }
      }
    }
    function isEqual(a, b) {
      var equal = true
      for (var item of a) {
        if (!b.includes(item)) {
          equal = false
          break
        }
      }
      for (var item of b) {
        if (!a.includes(item)) {
          equal = false
          break
        }
      }
      return equal
    }
    for (var i = 0; i < vs.length; i++) {
      var optionIndex = 'option' + (i + 1)
      var optionValues = []
      this.$ele.find('.grid-product-variant-input[data-index=' + optionIndex + ']:enabled option').each(function () {
        optionValues.push(this.value)
      })
      if (optionValues.length && vs[i].length && !isEqual(optionValues, vs[i])) {
        var $input = this.$ele.find('.grid-product-variant-input[data-index=option' + (i + 1) + ']:enabled')
        if ($input.is('select')) {
          $input.vselect('setOptions', vs[i])
        }
      }
    }
  }

  Collection.prototype.updateImage = function (variantId) {
    if (!variantId && this.current) {
      variantId = this.current.id
    }
    if (variantId) {
      var $img = this.$ele.find('.grid-product__color-image[data-variant-id="' + variantId + '"]')
      if (!$img.length) {
        return
      }
      $img.addClass('is-active')
      this.$ele.find('.grid-product__color-image').not($img).removeClass('is-active')
    }
  }

  Collection.prototype.updateColor = function () {
    var color = this.selectMap['Color']
    var $text = this.$ele
      .find('input[name=Color]')
      .closest('.grid-product-variant')
      .find('.grid-product-variant-title__right')
    if (!color || $text.length == 0 || $text.text() == color) {
      return
    }
    $text.text(color)
  }
  // =============  To Display compare_at_price of Ca =========================
  Collection.prototype.updatePripertiesVariantPrice = function (compareAtPrice, price) {
    let formEl = this.$ele?.[0]?.querySelector?.('form');
    if (!formEl) return;
    let v_compare_at_price = formEl.querySelector('[name="properties[original_price]"]');
    if (!compareAtPrice || compareAtPrice < price || !theme.pathMarketPrefix()) {
      v_compare_at_price?.remove?.()
      return;
    }
    if (!v_compare_at_price && compareAtPrice && compareAtPrice > price * 100) {
      v_compare_at_price = document.createElement('input')
      v_compare_at_price.setAttribute('type', 'hidden')
      v_compare_at_price.setAttribute('name', 'properties[original_price]')
      formEl.appendChild(v_compare_at_price)
    }
    if (compareAtPrice && compareAtPrice > price * 100) {
      v_compare_at_price.setAttribute('value',
        theme.Currency.formatMoney(
          compareAtPrice,
          theme.settings.moneyFormat
        ).replace('$', '')
      )
    }
  }
  Collection.prototype.updatePrice = function () {
    if (this.current) {
      this.$ele.find('.grid-product__price, .also-like-price').removeClass('grid-product__has-original')
      var compareAtPrice = this.current.compare_at_price
      var price = this.current.price
      var appliedDiscount = false
      if ((this.discountData && this.discountData[this.current.id])) {
        if (this.discountData[this.current.id].compareAtPrice) {
          compareAtPrice = this.discountData[this.current.id].compareAtPrice
        }
        if (this.discountData[this.current.id].auCompareAtPrice && window.location.pathname.startsWith('/en-au')) {
          compareAtPrice = this.discountData[this.current.id].auCompareAtPrice
        }else if (this.discountData[this.current.id].caCompareAtPrice && window.location.pathname.startsWith('/en-ca')) {
          compareAtPrice = this.discountData[this.current.id].caCompareAtPrice
        }
        if (this.discountData[this.current.id].price) {
          price = this.discountData[this.current.id].price
        }
        if (compareAtPrice > price) {
          var $original = this.$ele.find('.grid-product__price--original')
          if ($original.length) {
            if (this.current.id == 40482229649443 || this.current.id == 40482229714979 || this.current.id == 40480660848675 || this.current.id == 40480660815907) {
              $original.html(theme.Currency.formatMoney(
                compareAtPrice,
                theme.settings.moneyFormat
              ) + '<span class="composter-subscription-ab-test"> + 19.98/mo</span>')
            } else {
              $original.text(theme.Currency.formatMoney(
                compareAtPrice,
                theme.settings.moneyFormat
              ))
            }
          } else {
            this.$ele.find('.grid-product__price').after('<div class="grid-product__price--original">' + theme.Currency.formatMoney(
              compareAtPrice,
              theme.settings.moneyFormat
            ) + '</div>')
          }
          this.$ele
            .find('.grid-product__price, .also-like-price').addClass('grid-product__has-original')
          appliedDiscount = true
        }
      }
      if (!appliedDiscount) {
        this.$ele.find('.grid-product__price--original').remove()
        this.$ele.find('.grid-product__price, .also-like-price').removeClass('grid-product__has-original')
      }
      let composterSubPrice = ''
      if (this.current.id == 40482229649443 || this.current.id == 40482229714979) {
        composterSubPrice = '<span class="composter-subscription-ab-test"> + 16.66/mo</span>'
      } else if (this.current.id == 40480660848675 || this.current.id == 40480660815907) {
        composterSubPrice = '<span class="composter-subscription-ab-test"> + 19.98/mo</span>'
      }
      this.$ele
        .find('.grid-product__price, .also-like-price')
        .html(
          theme.Currency.formatMoney(
            price,
            theme.settings.moneyFormat
          )
          + composterSubPrice
        )
      this.updatePripertiesVariantPrice(compareAtPrice, price)
    }
  }

  /***
    *  collections/garden-beds page display `view product` button
    */
  Collection.prototype.updateBtnText = ($ele, btnText) => {
    $ele.text(btnText)
  }

  Collection.prototype.updatePreOrder = function () {
    if (this.current) {
      if (this.current.hasOwnProperty('available') && !this.current.available) {
        this.$ele.find('.add-to-cart').addClass('hide')
        this.$ele.find('a.btn-notify').removeClass('hide')
        var productUrl = this.$ele.find('a.btn-notify').data('href')
        this.$ele.find('a.btn-notify').attr('href', `${productUrl}?variant=${this.current.id}&immediately=1`)
      } else {
        var $option = this.$ele.find('option[value="' + this.current.id + '"]')
        var $form = this.$ele.find('form')
        $form.find('.gPreorderProperty').remove()
        $form.find('.gFullfillTsProperty').remove()
        var fulfillmentTs = $option.data('fulfillmentTs')
        var fulfillment = ts2shortDateFormat(fulfillmentTs * 1000)
        if ($option.data('preorder') && !theme.isAu()) {
          var btnText = 'Pre-order'
          if (fulfillmentTs) {
            var duration = fulfillmentTs - Math.round(Date.now() / 1000)
            if (duration > 0) {
              if (duration < 691200) {
                btnText = 'Add to Cart'
              } else if (duration < 1296000) {
                btnText = 'Add to Cart'
              }
            } else {
              btnText = 'Add to Cart'
            }
            $form.append(
              '<input type="hidden" class="gFullfillTsProperty" name="properties[_is_fullfillDate_ts]" value="' + fulfillmentTs + '">'
            )
          }
          this.$ele.find('.add-to-cart').removeClass('disabled').prop('disabled', false)
          if (this.$ele.closest('.you-might-also-like').length) {
            this.$ele.find('.add-to-cart').find('.grid-product-action > span').text('Add')
          } else {
            this.updateBtnText(this.$ele.find('.add-to-cart'), btnText)
          }
          $form.append(
            '<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Pre-order item">'
          )
          $form
            .find('.gFullfillProperty')
            .val("Ships by: " + fulfillment)
        } else {
          var btnText = 'Add to Cart'
          this.$ele.find('.add-to-cart').removeClass('disabled').prop('disabled', false)
          if (this.$ele.closest('.you-might-also-like').length) {
            this.$ele.find('.add-to-cart').find('.grid-product-action > span').text('Add')
          } else {
            this.updateBtnText(this.$ele.find('.add-to-cart'), btnText)
          }
          $form.find('.gFullfillProperty').val("In Stock")
        }
        this.$ele.find('.add-to-cart').removeClass('hide')
        this.$ele.find('a.btn-notify').addClass('hide')
      }
    }
  }

  Collection.prototype.updateEst = function () {
    //exclude some assigned product card
    if (this.$ele.hasClass('mug-bundle')) return
    if (this.current) {
      if (this.current.hasOwnProperty('available') && !this.current.available) {
        if (this.$ele.hasClass('grid-product__featured') || this.$ele.hasClass('product-block')) {
          this.$ele.find('.grid-product-est .grid-product-variant-title__left').text('Shipping Status')
          this.$ele.find('.grid-product-est__wrapper').html(
            '<span class="grid-product-est__field">Sold Out</span>'
          )
          this.$ele.find('.grid-product-est .grid-product-variant-title__tip').hide()
        } else {
          this.$ele.find('.grid-product-est').html('<span class="grid-product-est__field">Sold Out</span>')
        }
      } else {
        var $option = this.$ele.find('option[value="' + this.current.id + '"]')
        var fulfillmentTs = $option.data('fulfillmentTs')
        var fulfillment = ts2shortDateFormat(fulfillmentTs * 1000)
        if ($option.data('preorder') && !theme.isAu()) {
          if (this.$ele.hasClass('product-block')) {
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000)
              var fullflllText = fulfillment
              var close2weeks = false
              if (duration > 0) {
                if (duration < 691200) {
                  fullflllText = 'Ships in 1 week'
                  close2weeks = true
                } else if (duration < 1296000) {
                  fullflllText = 'Ships in 2 weeks'
                  close2weeks = true
                }
              } else {
                this.$ele.find('.grid-product-est .grid-product-variant-title__left').text('Shipping Status')
                this.$ele.find('.grid-product-est__wrapper').html(
                  '<span class="grid-product-est__field">In Stock</span>'
                )
                this.$ele.find('.grid-product-est .grid-product-variant-title__tip').hide()
                return
              }
              if (close2weeks) {
                this.$ele.find('.grid-product-est .grid-product-variant-title__left').text('Shipping Status')
                this.$ele.find('.grid-product-est__wrapper').html(
                  `<span class="grid-product-est__field">In Stock (${fullflllText})</span>`
                )
                this.$ele.find('.grid-product-est .grid-product-variant-title__tip').hide()
                return
              }
            }
            this.$ele.find('.grid-product-est .grid-product-variant-title__left').text('Ships by')
            this.$ele.find('.grid-product-est__wrapper').html(
              '<div class="grid-product-est__field">' +
              fullflllText +
              '</div>'
            )
            this.$ele.find('.grid-product-est .grid-product-variant-title__tip').show()
          } else {
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000)
              if (duration > 0) {
                if (duration < 691200) {
                  this.$ele.find('.grid-product-est').html(`<span class="grid-product-est__field">In Stock (Ships in 1 week)</span>`)
                  return
                } else if (duration < 1296000) {
                  this.$ele.find('.grid-product-est').html(`<span class="grid-product-est__field">In Stock (Ships in 2 weeks)</span>`)
                  return
                }
              } else {
                this.$ele.find('.grid-product-est').html('<span class="grid-product-est__field">In Stock</span>')
                return
              }
            }
            this.$ele
              .find('.grid-product-est')
              .html(
                '<span class="grid-product-est__field">Ships by ' +
                fulfillment +
                '</span><span class="grid-product-est__tip" data-toggle="tooltip" data-arrow title="<p>Existing orders not affected.</p><p>The expected ship date is the date by which we expect to ship an item, and not the delivery date. Expected ship dates are subject to change, and will be communicated to the customer.</p>">' +
                '<svg class="vegoicon vegoicon-info"><use xlink:href="#vegoicon-info"></use></svg>'
                + '</span>'
              )
            $('[data-toggle="tooltip"]').tooltip()
          }
        } else {
          if (this.$ele.hasClass('product-block')) {
            this.$ele.find('.grid-product-est .grid-product-variant-title__left').text('Shipping Status')
            this.$ele.find('.grid-product-est__wrapper').html(
              '<span class="grid-product-est__field">In Stock</span>'
            )
            this.$ele.find('.grid-product-est .grid-product-variant-title__tip').hide()
          } else {
            this.$ele.find('.grid-product-est').html('<span class="grid-product-est__field">In Stock</span>')
          }
        }
      }
    }
  }

  Collection.prototype.getDiscountText = function (price, compareAtPrice, refund, multiBadge, disacountData, isFlashSaleCountDown) {
    var savedAmount = compareAtPrice - price
    var savedPercent = Math.round((compareAtPrice - price) * 100 / compareAtPrice)
    if (disacountData.percent || savedPercent >= savedAmount / 100) {
      if (isFlashSaleCountDown) {
        return savedPercent + '% OFF'
      }
      if (multiBadge) {
        return "-" + savedPercent + "%"
      }
      return savedPercent + '% OFF'
    } else {
      if (isFlashSaleCountDown) {
        return theme.Currency.formatMoney(
          savedAmount,
          '${{amount_no_decimals}}'
        ) + ' OFF'
      }
      if (multiBadge) {
        return "-" + theme.Currency.formatMoney(
          savedAmount,
          '${{amount_no_decimals}}'
        )
      }
    }
    return (refund ? 'Save' : 'SAVE') + ' ' + theme.Currency.formatMoney(
      savedAmount,
      '${{amount_no_decimals}}'
    )
  }

  Collection.prototype.updateDiscount = function () {
    if (this.current) {
      var compareAtPrice = this.current.compare_at_price
      var price = this.current.price
      var appliedDiscount = false
      var badgeClass = 'badge-flash'
      // if (this.$ele.data('productHandle') == '4-pack-17-tall-6-in-1-modular-metal-raised-garden-bed-kit') {
      //   if (this.$ele.find('.grid-product-badge--discount').length) {
      //     if (!this.$ele.find('.holiday-pick').length) {
      //       var isFlashSaleCountDown = !!this.$ele.find('.grid-product-badge--discount').closest('.flash-sale-grid-product-badge').length
      //       this.$ele.find('.grid-product-badge--discount')
      //         .replaceWith('<div class="grid-product-badge ' + badgeClass + ' grid-product-badge--discount">Buy 3 Get 1 Free</div>')
      //     }
      //   } else {
      //     if (!this.$ele.find('.holiday-pick').length) {
      //       this.$ele.find('.grid-product-badges')
      //         .prepend('<div class="grid-product-badge ' + badgeClass + ' grid-product-badge--discount">Buy 3 Get 1 Free</div>')
      //     }
      //   }
      //   appliedDiscount = true
      // } else {
        if (this.discountData && this.discountData[this.current.id]) {
          if (this.discountData[this.current.id].compareAtPrice) {
            compareAtPrice = this.discountData[this.current.id].compareAtPrice
          }
          if (this.discountData[this.current.id].auCompareAtPrice && window.location.pathname.startsWith('/en-au')) {
            compareAtPrice =
              this.discountData[this.current.id].auCompareAtPrice;
          }else if (this.discountData[this.current.id].caCompareAtPrice && window.location.pathname.startsWith('/en-ca')) {
            compareAtPrice = this.discountData[this.current.id].caCompareAtPrice
          }
          if (this.discountData[this.current.id].price) {
            price = this.discountData[this.current.id].price
          }
          if (compareAtPrice > price) {
            var refund = ''
            var multiBadge = !!this.$ele.data('multiBadge')
            if (this.$ele.data('refund')) {
              if (!window.location.pathname.startsWith('/en-ca')) {
                refund = ' <a href="/pages/kids-program">+ ' + this.$ele.data('refund') + ' Refund</a>'
              }
              badgeClass = 'badge-stockout'
            }
            if (this.$ele.find('.grid-product-badge--discount').length) {
              var isFlashSaleCountDown = !!this.$ele.find('.grid-product-badge--discount').closest('.flash-sale-grid-product-badge').length
              if (!this.$ele.find('.holiday-pick').length) {
                this.$ele.find('.grid-product-badge--discount')
                  .replaceWith('<div class="grid-product-badge ' + badgeClass + ' grid-product-badge--discount">' +
                    this.getDiscountText(price, compareAtPrice, refund, multiBadge, this.discountData[this.current.id], isFlashSaleCountDown) + refund + '</div>')
              }
            } else {
              if (!this.$ele.find('.holiday-pick').length) {
                this.$ele.find('.grid-product-badges')
                  .prepend('<div class="grid-product-badge ' + badgeClass + ' grid-product-badge--discount">' +
                    this.getDiscountText(price, compareAtPrice, refund, multiBadge, this.discountData[this.current.id], isFlashSaleCountDown) + refund + '</div>')
              }
            }
            appliedDiscount = true
          }
        }
      // }
      if (!appliedDiscount) {
        this.$ele.find('.grid-product-badge--discount').remove()
      }
    }
  }

  function Plugin(dataKey, construct) {
    return function (option) {
      return this.each(function (index, item) {
        var $this = $(item)
        var data = $this.data(dataKey)
        if (
          typeof option == 'undefined' ||
          (typeof option == 'object' && option)
        ) {
          if (!data) $this.data(dataKey, (data = new construct(this, option)))
        }
        if (typeof option == 'string') {
          data[option].apply(data, Array.prototype.slice.call(arguments, 1))
        }
      })
    }
  }

  $.fn.collecionProduct = Plugin('vego.collection.product', Collection)
  $.fn.collecionProduct.Constructor = Collection

  $(function () {
    var videoControl = $('.collection-video__control')
    if (videoControl.length > 0) {
      videoControl.on('click', function () {
        $(this)
          .closest('.video-section__media')
          .find('.collection-video__poster')
          .hide()
        $(this).hide()
      })
    }
  })
})()
  ; +(function ($, window) {
    function ArticleProduct(ele) {
      this.$ele = $(ele)
      this.initVariants()
      if (this.variantData) {
        this.initEvent()
      }
    }

    ArticleProduct.prototype.initVariants = function () {
      var jsonEle = this.$ele.find('.variant-json')
      if (jsonEle.length == 0) {
        return
      }
      this.variantData = JSON.parse(jsonEle.text())
    }

    ArticleProduct.prototype.initEvent = function () {
      this.$ele.on('change', '.product-variants select', this.onSelectChange.bind(this))
    }

    ArticleProduct.prototype.onSelectChange = function (e) {
      this.getCurrentVariantData()
      this.updateImage()
      this.updatePreOrder()
    }

    ArticleProduct.prototype.getCurrentVariantData = function () {
      var vid = this.$ele.find('.product-variants select').val()
      this.current = this.variantData.find(e => e.id == vid)
    }

    ArticleProduct.prototype.updateImage = function (variantId) {
      if (!variantId && this.current) {
        variantId = this.current.id
      }
      if (variantId) {
        var $img = this.$ele.find('.grid-product__color-image[data-variant-id="' + variantId + '"]')
        if (!$img.length) {
          return
        }
        $img.addClass('is-active')
        this.$ele.find('.grid-product__color-image').not($img).removeClass('is-active')
      }
    }

    ArticleProduct.prototype.updatePreOrder = function () {
      if (this.current) {
        if (this.current.hasOwnProperty('available') && !this.current.available) {
          this.$ele.find('.add-to-cart').addClass('hide')
          this.$ele.find('a.btn-notify').removeClass('hide')
          var productUrl = this.$ele.find('a.btn-notify').data('href')
          this.$ele.find('a.btn-notify').attr('href', `${productUrl}?variant=${this.current.id}&immediately=1`)
        } else {
          var $option = this.$ele.find('option[value="' + this.current.id + '"]')
          var $form = this.$ele.find('form')
          $form.find('.gPreorderProperty').remove()
          $form.find('.gFullfillTsProperty').remove()
          var fulfillmentTs = $option.data('fulfillmentTs')
          var fulfillment = ts2shortDateFormat(fulfillmentTs * 1000)
          if ($option.data('preorder')) {
            var btnText = 'Pre-order'
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000)
              if (duration > 0) {
                if (duration < 691200) {
                  btnText = 'Add to Cart'
                } else if (duration < 1296000) {
                  btnText = 'Add to Cart'
                }
              } else {
                btnText = 'Add to Cart'
              }
              $form.append(
                '<input type="hidden" class="gFullfillTsProperty" name="properties[_is_fullfillDate_ts]" value="' + fulfillmentTs + '">'
              )
            }
            this.$ele.find('.add-to-cart').removeClass('disabled').prop('disabled', false)
            this.updateBtnText(this.$ele.find('.add-to-cart'), btnText)
            $form.append(
              '<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Pre-order item">'
            )
            $form
              .find('.gFullfillProperty')
              .val("Ships by: " + fulfillment)
          } else {
            var btnText = 'Add to Cart'
            this.$ele.find('.add-to-cart').removeClass('disabled').prop('disabled', false)
            this.updateBtnText(this.$ele.find('.add-to-cart'), btnText)
            $form.find('.gFullfillProperty').val("In Stock")
          }
          this.$ele.find('.add-to-cart').removeClass('hide')
          this.$ele.find('a.btn-notify').addClass('hide')
        }
      }
    }

    ArticleProduct.prototype.updateBtnText = ($ele, btnText) => {
      $ele.text(btnText)
    }

    function Plugin(dataKey, construct) {
      return function (option) {
        return this.each(function (index, item) {
          var $this = $(item)
          var data = $this.data(dataKey)
          if (
            typeof option == 'undefined' ||
            (typeof option == 'object' && option)
          ) {
            if (!data) $this.data(dataKey, (data = new construct(this, option)))
          }
          if (typeof option == 'string') {
            data[option].apply(data, Array.prototype.slice.call(arguments, 1))
          }
        })
      }
    }

    $.fn.articleProduct = Plugin('vego.article.product', ArticleProduct)
    $.fn.articleProduct.Constructor = ArticleProduct

    $(function () {
      $('.article-product-card').articleProduct()
    })
  })($, window)
  ; +(function ($, window) {
    function Select(ele, opt) {
      this.$ele = $(ele)
      this.show = false
      this.images = {}
      this.textMode = this.$ele.data('text') || 'text'
      if (this.$ele.is('select')) {
        this.build()
      } else {
        this.onlyUi = true
        try {
          var target = this.$ele.data('target')
          if (target.includes('=')) {
            this.$target = $(
              '.product-single__meta [' +
              target +
              ']:enabled'
            )
          } else {
            this.$target = $(this.$ele.data('target'))
          }
        } catch (e) {
          this.$target = $(
            '.product-single__meta [name="' +
            this.$ele.data('target') +
            '"]:enabled'
          )
        }
        if (!this.$target.length) {
          this.$target = $(
            '.product-single__meta [name="' +
            this.$ele.data('target') +
            '"]:enabled'
          )
        }

        this.$selector = this.$ele
        this.$select = this.$ele.find('.vego-select')
        this.$dropdown = this.$ele.find('.vego-select-dropdown')
      }
      let options = {
        // placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8]
              // offset: ({ placement, reference, popper }) => {
              //   console.log(placement, reference, popper);
              //   if (placement === 'bottom') {
              //     return [0, popper.height / 2];
              //   } else {
              //     return [0, 8];
              //   }
              // },
              // fn({ state }) {
              //   const overflow = detectOverflow(state);
              //   console.log(overflow);
              // },
            },
          }
        ],
      };
      if (this.$ele.data('strategy')) {
        options.strategy = this.$ele.data('strategy')
      }
      if (opt.placement) {
        options.placement = opt.placement;
      }
      this.popper = Popper.createPopper(this.$select[0], this.$dropdown[0], options)
      this.init()
    }

    Select.GLOBAL_EVENT_ADD = false

    Select.prototype.build = function () {
      this.$options = this.$ele.find('option')
      this.$selector = this.$ele.parent('.vego-select-contaner')
      if (!this.$selector.length) {
        this.$selector = $('<div class="vego-select-contaner"></div>')
        this.$ele.parent().append(this.$selector)
        this.$ele.appendTo(this.$selector)
      }
      this.$select = this.$selector.find('.vego-select')
      this.$dropdown = this.$selector.find('.vego-select-dropdown')
      if (!this.$select.length) {
        this.$select = $('<div class="vego-select"  type="button" tabindex="0" ></div>')
        this.$selector.prepend(this.$select)
      }
      if (!this.$dropdown.length) {
        this.$dropdown = $('<div class="vego-select-dropdown"></div>')
        this.$selector.prepend(this.$dropdown)
      }
      this.$dropdownContent = this.$dropdown.find('.vego-select-dropdown-content')
      if (!this.$dropdownContent.length) {
        this.$dropdownContent = $('<div class="vego-select-dropdown-content"></div>')
        this.$dropdown.append(this.$dropdownContent)
      }
      var _this = this
      var template =
        '<ul class="vego-select-menu">'
      this.$options.each(function () {
        template +=
          '<li class="vego-select-item' +
          ($(this).prop('selected') ? ' active' : '') +
          '" data-name="' + theme.htmlEncode($(this).html().split(' ').join('-')) + '" data-value="' +
          theme.htmlEncode($(this).val()) +
          '">'
        if ($(this).data('img')) {
          template +=
            '<div class="color-swatch__label ' + (_this.textMode === 'html-md' ? 'small--hide' : '') + '">' +
            '    <img class="color-swatch__image" loading="lazy" src="' +
            $(this).data('img') +
            '" alt="Color Vego Garden" />' +
            '</div>' +
            '<span>' +
            $(this).html() +
            '</span>'
          _this.images[theme.htmlEncode($(this).val())] = $(this).data('img')
        } else {
          template += $(this).html()
        }
        $(this).html() + '</li>'
      })
      template += '</ul>'
      this.$dropdownContent.html(template)
      var $active = this.$dropdownContent.find('.vego-select-item.active')
      this.$select.html(this.textMode.indexOf('html') > -1 ? $active.html() : $active.text())
      if (!this.$dropdown.find('.vego-select-dropdown__arrow').length) {
        this.$dropdown.append('<div class="vego-select-dropdown__arrow" data-popper-arrow></div>')
      }
    }

    Select.prototype.initEvent = function () {
      if (!Select.GLOBAL_EVENT_ADD) {
        $(document.body).on('click', function (e) {
          $('select.grid-product-variant-input:enabled').vselect('dismiss', e)
          $('[data-ui="select"]').vselect('dismiss', e)
        })
        $(window).on('scroll', function (e) {
          $('select.grid-product-variant-input:enabled').vselect('dismiss', e)
          $('[data-ui="select"]').vselect('dismiss', e)
        })
        $('.vego-cart-recommend,.cart-container').on('scroll', function (e) {
          $('select.grid-product-variant-input:enabled').vselect('dismiss', e)
          $('[data-ui="select"]').vselect('dismiss', e)
        })
        Select.GLOBAL_EVENT_ADD = true
      }
    }

    Select.prototype.setOptions = function (options) {
      var selected = this.$ele.val()
      var triggerEvent = false
      if (!options.some(function (e) { return e === selected })) {
        selected = options[0]
        triggerEvent = true
      }
      var optionsTemplate = ''
      let _this = this;
      options.forEach(function (s, index) {
        /**
        * # -------------------------------- composter subscription action --------------------------------
        * ## sync sell_plan id for select customizations
        */
        let optionItem = _this.$ele.find('option')[index]
        let appendOption = ''
        if (optionItem && optionItem.getAttribute?.('data-sell_plan')) {
          appendOption = `data-sell_plan="${optionItem.getAttribute('data-sell_plan')}"`
        }
        optionsTemplate += '<option ' + (selected === s ? 'selected="selected"' : '') +
          ' value="' + theme.htmlEncode(s) + '" class="variant-input"  ' + appendOption + ' data-name="'
          + theme.htmlEncode(s).split(' ').join('-') + '" '
          + (_this.images[s] ? 'data-img="' + _this.images[s] + '"' : '') + '>' + theme.htmlEncode(s) + '</option>'
      })

      this.$ele.empty()
      this.$ele.append(optionsTemplate)
      this.build()
      if (triggerEvent) {
        theme.utils.trigger(this.$ele, 'change')
      }
    }

    Select.prototype.init = function () {
      var _this = this
      this.currentValue = this.$selector.find('.vego-select').text().trim()
      this.$select.on('click', function (e) {
        e.preventDefault()
        if (_this.show) {
          _this.doHide()
        } else {
          _this.doShow()
        }
      })
      this.$dropdown.on('click', '.vego-select-item', function (e) {
        e.preventDefault()
        e.stopPropagation()
        var $this = $(e.target).closest('.vego-select-item')
        if ($this.hasClass('disabled')) {
          return
        }
        _this.select($this.data('value'))
      })
      this.$dropdown.on('touchstart mousedown', this.touchHandler);
      this.$dropdown.on('touchmove mousemove', this.touchHandler);
      this.$dropdown.on('touchend mouseup', this.touchHandler);
      this.$dropdown.on('touchcancel mouseleave', this.touchHandler);

      this.initEvent()
    }

    Select.prototype.touchHandler = function (e) {
      e.stopPropagation()
    }

    Select.prototype.select = function (value) {
      var _this = this;
      var isHtml = _this.textMode.indexOf("html") > -1;
      value = value && (value + "").trim();
      if (this.currentValue == value) {
        this.doHide();
        return;
      }
      let p_el_class = _this.$ele.attr("set-value-parent-ele");
      if (p_el_class) {
          _this.$ele.closest(`.${p_el_class}`).find('form [name="id"]').attr('value',value);
      }
      this.$selector.find(".vego-select-item").each(function (idx) {
        if ($(this).data("value") == value) {
          $(this).addClass("active");
          if (isHtml) {
            _this.$select.html($(this).html());
          } else {
            _this.$select.text($(this).text());
          }
          _this.currentValue = value;

          if (_this.onlyUi) {
            if (_this.$target.is("input")) {
              if (_this.$target[0].type == "radio") {
                _this.$target.each(function () {
                  if ($(this).val() == value) {
                    $(this).prop("checked", true);
                  }
                });
              } else {
                _this.$target.val(value);
              }
              theme.utils.trigger(_this.$target, "change");
            } else if (_this.$target.is("select")) {
              _this.$target.vselect("select", value);
              theme.utils.trigger(_this.$target, "change");
            }
          } else {
            _this.$ele.val(value);
            theme.utils.trigger(_this.$ele, "change");
          }
          _this.doHide();
        } else {
          $(this).removeClass("active");
        }
      });
    }

    Select.prototype.doHide = function () {
      this.$dropdown.removeClass('show')
      this.$selector.removeClass('open')
      this.show = false
    }

    Select.prototype.doShow = function () {
      this.$dropdown.addClass('show')
      this.$selector.addClass('open')
      var _this = this
      if (this.onlyUi) {
        if (this.$target.is('input')) {
          this.$target.each(function (idx) {
            if ($(this).prop('disabled')) {
              _this.$selector
                .find('.vego-select-item')
                .eq(idx)
                .addClass('disabled')
            }
          })
        }
      } else {
        this.$options.each(function (idx) {
          if ($(this).prop('disabled')) {
            _this.$selector.find('.vego-select-item').eq(idx).addClass('disabled')
          }
        })
      }

      this.popper.update()
      this.show = true
    }

    Select.prototype.dismiss = function (e) {
      if (!this.show) {
        return
      }
      if (e.target == this.$select[0] || $.contains(this.$select[0], e.target)) {
        return
      }
      if (this.show && !$.contains(this.$dropdown[0], e.target)) {
        this.doHide()
      }
    }

    function Plugin(option) {
      var args = Array.prototype.slice.call(arguments, 1)
      return this.each(function () {
        var $this = $(this)
        var data = $this.data('vego.select')
        var options = typeof option == 'object' && option

        if (!data && /destroy|hide/.test(option)) return
        if (!data) $this.data('vego.select', (data = new Select(this, options)))
        if (typeof option == 'string') data[option].apply(data, args)
      })
    }

    var old = $.fn.vselect

    $.fn.vselect = Plugin
    $.fn.vselect.Constructor = Select

    // POPOVER NO CONFLICT
    // ===================

    $.fn.vselect.noConflict = function () {
      $.fn.vselect = old
      return this
    }
    $.$$updateInput = function () {

      if (!theme.isMobile()) {
        $('.grid-product-variant-input').each(function () {
          if(!!$(this).closest('.disabled-updateInput').length)return;
          if (
            $(this).is('.medium-up--hide') ||
            $(this).closest('.medium-up--hide').length > 0
          ) {
            $(this).prop('disabled', true)
          } else {
            $(this).prop('disabled', false)
          }
        })
      } else {
        $('.grid-product-variant-input').each(function () {
          if (!!$(this).closest(".disabled-updateInput").length) return;
          if (
            $(this).is('.small--hide') ||
            $(this).closest('.small--hide').length > 0
          ) {
            if (!$(this).prop('disabled')) {
              $(this).prop('disabled', true)
            }
          } else {
            $(this).prop('disabled', false)
          }
        })
      }
    }
  })(jQuery, window)
  ; +(function ($) {
    'use strict'

    // TAB CLASS DEFINITION
    // ====================

    var Tab = function (element) {
      // jscs:disable requireDollarBeforejQueryAssignment
      this.element = $(element)
      // jscs:enable requireDollarBeforejQueryAssignment
    }

    Tab.TRANSITION_DURATION = 150

    Tab.prototype.show = function () {
      var $this = this.element
      var $ul = $this.closest('ul:not(.dropdown-menu)')
      var selector = $this.data('target')

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
      }

      if ($this.parent('li').hasClass('active')) return

      var $previous = $ul.find('.active:last a')
      var hideEvent = $.Event('hide.vego.tab', {
        relatedTarget: $this[0],
      })
      var showEvent = $.Event('show.vego.tab', {
        relatedTarget: $previous[0],
      })

      $previous.trigger(hideEvent)
      $this.trigger(showEvent)

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

      var $target = $(document).find(selector)

      this.activate($this.closest('li'), $ul)
      this.activate($target, $target.parent(), function () {
        $previous.trigger({
          type: 'hidden.vego.tab',
          relatedTarget: $this[0],
        })
        $this.trigger({
          type: 'shown.vego.tab',
          relatedTarget: $this[0],
        })
      })
    }

    Tab.prototype.activate = function (element, container, callback) {
      var $active = container.find('> .active')
      var outWidth = element.closest('ul').outerWidth()
      var curWidth = element.outerWidth()
      var left = element[0].offsetLeft
      var scrollLeft = element.closest('ul').scrollLeft()
      if (scrollLeft > left) {
        element.closest('ul').scrollLeft(left)
      } else if (left + curWidth - scrollLeft > outWidth) {
        element.closest('ul').scrollLeft(left + curWidth - outWidth)
      }
      var transition = callback && $active.length
      function next() {
        $active
          .removeClass('active')
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

        element
          .addClass('active')
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

        if (transition) {
          element[0].offsetWidth // reflow for transition
          element.css('opacity', '1')
        }

        callback && callback()
      }

      transition ? $active.one('transitionend', next) : next()

      $active.css('opacity', '')
    }

    // TAB PLUGIN DEFINITION
    // =====================

    function Plugin(option) {
      return this.each(function () {
        var $this = $(this)
        var data = $this.data('vego.tab')

        if (!data) $this.data('vego.tab', (data = new Tab(this)))
        if (typeof option == 'string') data[option]()
      })
    }

    var old = $.fn.tab

    $.fn.tab = Plugin
    $.fn.tab.Constructor = Tab

    // TAB NO CONFLICT
    // ===============

    $.fn.tab.noConflict = function () {
      $.fn.tab = old
      return this
    }

    // TAB DATA-API
    // ============

    var clickHandler = function (e) {
      e.preventDefault()
      Plugin.call($(this), 'show')
    }

    $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
  })(jQuery)
  ; +(function ($) {
    'use strict'
    $.fn.emulateTransitionEnd = function (duration) {
      var called = false
      var $el = this
      $(this).one('transitionend', function () { called = true })
      var callback = function () { if (!called) $($el).trigger('transitionend') }
      setTimeout(callback, duration)
      return this
    }
    var tooltipId = 10000
    // TAB CLASS DEFINITION
    // ====================
    var template = '<div class="vego-tooltip" role="tooltip"></div>'
    var Tooltip = function (element) {
      // jscs:disable requireDollarBeforejQueryAssignment
      this.$element = $(element)
      // jscs:enable requireDollarBeforejQueryAssignment
      this.title = this.$element.attr('title')
      this.mediaQuery = this.$element.data('tooltipMedia')
      this.$element.attr('title', '')
      this.$element.attr('data-original-title', this.title)
      this.$element.attr('tabindex', tooltipId)
      tooltipId++
      this._setListeners()
    }

    Object.assign(Tooltip.prototype, {
      _setListeners: function () {
        if (this.mediaQuery === 'medium' && $(window).width() < 768) {
          return
        }
        if ($(window).width() < 768) {
          this.$element.on('touchstart', (e) => {
            if (this.tip && this.tip.hasClass('show')) {
              this._leave(e)
            } else {
              this._enter(e)
            }
          })
        } else {
          this.$element.on('mouseenter', this._enter.bind(this))
        }
        this.$element.on('mouseleave', this._leave.bind(this))
        this.$element.on('blur', this._leave.bind(this))
        this.$element.on('click', function (e) { e.preventDefault })
        $(window).on('scroll', this._leave.bind(this))
      },
      show: function () {
        if (!this.tip) {
          this.tip = $(template)
          let append_info = ''

          if (
            this.title.startsWith("Some add-ons in your cart are incompatible")
          ) {
            append_info = `<div class="line-item"><svg class="vegoicon vegoicon-phone" aria-hidden="true" role="presentation" viewBox="0 0 24 24"><g><g clip-path="url(#eaa)" stroke="#3A5B39" stroke-width="1.5"><circle cx="12" cy="12" r="11"></circle><path d="M17.22 13.762a9.97 9.97 0 0 0-1.166-.716c-.587-.308-.85-.346-.988-.346-.301 0-.564.154-.772.462a3.752 3.752 0 0 0-.325.631c-.046.1-.123.293-.185.393-.116-.039-.393-.154-.888-.493a11.026 11.026 0 0 1-1.42-1.155c-.394-.4-.826-.932-1.158-1.425-.34-.5-.455-.77-.494-.886.1-.061.286-.138.402-.192.216-.093.44-.193.625-.324.3-.208.455-.47.455-.77 0-.146-.038-.4-.347-.993-.185-.354-.44-.77-.718-1.163-.208-.293-.517-.716-.85-1.055-.385-.4-.679-.578-.964-.578-.656 0-1.374.87-1.66 1.24-.27.377-.919 1.332-.919 2.241 0 .847.556 1.933 1.027 2.696A18.417 18.417 0 0 0 9.3 14.394l.309.308c.965.94 2.053 1.802 3.065 2.426.764.47 1.845 1.024 2.694 1.024.91 0 1.868-.647 2.238-.924.371-.277 1.243-1.001 1.243-1.656 0-.285-.177-.585-.579-.97a9.981 9.981 0 0 0-1.05-.84Z"></path></g><defs><clipPath id="eaa"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs></g></svg><span>Phone:&nbsp;<a href="tel:+18665971888" class="service-link" aria-label="Go to (866) 597-1888">(866) 597-1888</a></span></div>`;
          }
          this.tip.html(this.title + append_info)
          if (this.$element.is('[data-arrow]')) {
            this.tip.append(
              '<div class="vego-tooltip-arrow" data-popper-arrow></div>'
            )
          }
          $(document.body).append(this.tip)
        }
        if ('ontouchstart' in document.documentElement) {
          $(document.body).children().on('mouseover', null, function (e) { e.preventDefault() })
        }
        this.popper = Popper.createPopper(this.$element[0], this.tip[0], {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-10, 8],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                padding: 10,
              },
            },
          ],
        })
        this.$element.focus()
        this.tip.addClass('show')
      },
      _enter: function (e) {
        e.preventDefault()
        this.show()
      },
      _leave: function () {
        if (!this.tip) return
        this.tip.removeClass('show')
        var _this = this
        this.tip.on('transitionend', function () {
          if (_this.tip && !_this.tip.hasClass('show')) {
            if (_this.popper) {
              _this.popper.destroy()
            }
            _this.tip.off('transitionend')
            _this.tip.remove()
            _this.tip = null
          }
        }).emulateTransitionEnd(300)
      },
    })

    // TAB PLUGIN DEFINITION
    // =====================

    function Plugin(option) {
      return this.each(function () {
        var $this = $(this)
        var data = $this.data('vego.tooltip')

        if (!data) $this.data('vego.tooltip', (data = new Tooltip(this)))
        if (typeof option == 'string') data[option]()
      })
    }

    var old = $.fn.tooltip

    $.fn.tooltip = Plugin
    $.fn.tooltip.Constructor = Tooltip

    $.fn.tooltip.noConflict = function () {
      $.fn.tooltip = old
      return this
    }

    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  })(jQuery)
  ; +(function ($) {

    function ChoosePanel(ele, options = {}) {
      this.$panel = $(ele)
      this.$actionBar = $('.action-bar')
      this.$colorImage = this.$actionBar.find('.vego-select .color-swatch__image, .bar-variant-color > .color-swatch__label .color-swatch__image')
      this.options = Object.assign({
        threshold: 810
      }, options)
      this.$variantColor = this.$actionBar.find('.bar-variant-color')
      this.panelOpen = !!options.initialOpen
      this.initEvents()
    }

    ChoosePanel.prototype.initEvents = function () {
      var _this = this
      this.$variantColor.on('click', this.onTogglePanel.bind(this))
      this.$panel.on('click', 'button', this.onCheck.bind(this))
      $(window).on('scroll', function () {
        var scrollTop = document.documentElement.scrollTop;
        if (!$('.mobile-sticky-product-details').hasClass('out') && scrollTop > _this.options.threshold) {
          $('.mobile-sticky-product-details').addClass('out')
          $('#fc_frame').hide()
          $('#attentive_overlay').hide()
          $('.vego-footer-area').css('padding-bottom', '102px')
          if (window.innerWidth < 768) {
            $('.scroll-top').css('bottom', '170px')
          } else {
            $('.scroll-top').css('bottom', '180px')
          }

        } else if (scrollTop < _this.options.threshold && $('.mobile-sticky-product-details').hasClass('out')) {
          $('.mobile-sticky-product-details').removeClass('out')
          $('#fc_frame').show()
          $('#attentive_overlay').show()
          $('.vego-footer-area').css('padding-bottom', '')
          $('.scroll-top').css('bottom', '160px')
        }
        if (_this.panelOpen) {
          _this.hidePanel()
        }
      })
    }

    ChoosePanel.prototype.onTogglePanel = function (e) {
      if (this.panelOpen) {
        this.hidePanel()
      } else {
        this.showPanel()
      }
    }

    ChoosePanel.prototype.onCheck = function (e) {
      e.preventDefault()
      var $target = $(e.currentTarget)
      if ($target.hasClass('active')) {
        return
      }
      $target.siblings('.active').removeClass('active')
      $target.addClass('active')
      var image = $target.find('.color-swatch__image').attr('src')
      this.$colorImage.attr('src', image)
      $('.product-single__meta [name=Color]:enabled').each((i, ele) => {
        if ($(ele).is('select')) {
          $(ele).vselect(
            'select',
            $target.find('.color-text').text()
          )
        } else if ($(ele).is('input[type=radio]')) {
          if (ele.value === $target.find('.color-text').text()) {
            $(ele).prop('checked', true)
            theme.utils.trigger(ele, 'change')
          }
        }
      })
      if (this.panelOpen) {
        this.hidePanel()
      }
    }

    ChoosePanel.prototype.check = function (value) {
      var checkText
      this.$panel.find('.color-text').each(function () {
        if ($(this).text() == value) {
          checkText = $(this)
        }
      })
      if (checkText) {
        this.$panel.find('button').removeClass('active')
        var image = checkText.closest('button').addClass('active').find('.color-swatch__image').attr('src')
        this.$colorImage.attr('src', image)

        this.$actionBar.find('.vego-select .color-swatch__label > span').text(value)

        if (window.location.href.indexOf('products/kitchen-composter') > -1)
          this.$actionBar.find('.bar-variant--title+.color-swatch__label .visually-hidden').text(value)
      }
    }



    ChoosePanel.prototype.showPanel = function () {
      this.panelOpen = true
      this.$panel.addClass('out')
      this.$dropback = $('<div class="modal-backdrop"></div>')
      $(document.body).append(this.$dropback)
      this.$dropback.on('click', this.hidePanel.bind(this))
      this.$dropback.addClass('in')
    }

    ChoosePanel.prototype.hidePanel = function () {
      this.panelOpen = false
      this.$panel.removeClass('out')
      this.$dropback.off('click', this.hidePanel.bind(this))
      this.$dropback.removeClass('in')
        .on('transitionend', function () {
          $(this).remove()
        }).emulateTransitionEnd(150)
    }

    // ChoosePanel PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
      var args = Array.prototype.slice.call(arguments, 1)
      return this.each(function () {
        var $this = $(this)
        var data = $this.data('vego.choosePanel')
        if (!data)
          $this.data('vego.choosePanel', (data = new ChoosePanel(this, option)))
        if (typeof option == 'string') data[option].apply(data, args)
      })
    }

    var old = $.fn.cp

    $.fn.cp = Plugin
    $.fn.cp.Constructor = ChoosePanel

    // ChoosePanel NO CONFLICT
    // ====================

    $.fn.cp.noConflict = function () {
      $.fn.cp = old
      return this
    }
    $(function () {
      $('.choose-panel').cp()
    })
  })(jQuery)
  ; +(function ($) {
    function Tabs({ wrapName, linePosition = 'left', autoScroll = false, element }) {
      if (element) {
        this.$element = $(element)
      } else {
        this.$element = $(wrapName)
      }
      if (!this.$element.length) {
        return
      }
      this.$element.data('vego.tabs', this)
      this.autoScroll = autoScroll
      this.linePosition = linePosition
      this.init()
    }

    Tabs.prototype.init = function() {
      this.$tabItem = this.$element.find('.vego-tab--item');
      if (this.$tabItem.length) {
        var _this = this
        this.$content = this.$element.find('.vego-tab-header--wrap')
        this.contentWidth = this.$content.outerWidth()
        this.distance = []
        this.currentIndex = 0
        this.$tabItem.each(function (i, e) {
          _this.distance[i] = e.offsetLeft
          if ($(e).hasClass('active')) {
            _this.currentIndex = i
          }
          e.dataset.index = i
        })
        this.$prev = this.$element.find('.arrow-left')
        this.$next = this.$element.find('.arrow-right')
        this.$line = this.$element.find(' .vego-tab-line')
        this.$head = this.$element.find('.vego-tab-header')
        this.maxScrollLeft = this.$head[0].scrollWidth - this.$head.width()
        this.initEvents()
        this.setTab(this.currentIndex)
      } else {
        this.$element.find('.vego-tab-content-item').show()
      }
    }

    Tabs.prototype.initEvents = function () {
      var _this = this
      this.$element.on('click', '.vego-tab--item, .faq-tab-item', function () {
        
        _this.setTab.call(_this, $(this).index())
      })
      this.$prev.on('click', function () {
        _this.setTab(_this.currentIndex - 1)
      })
      this.$next.on('click', function () {
        _this.setTab(_this.currentIndex + 1)
      })
    }

    Tabs.prototype.setTab = function (index) {
      this.currentIndex = index
      this.$element.find('.vego-tab--item').removeClass('active')
      var $item = this.$element
        .find('.vego-tab--item')
        .eq(index)
        .addClass('active')
      if (this.linePosition === 'center') {
        this.$element.find('.faq-tab-item').removeClass('active')
        this.$element.find('.faq-tab-item').eq(index).addClass('active')
      }
      if (!isMobile.any && this.linePosition === 'left') {
        var scrollLeft =
          $item[0].offsetLeft > this.contentWidth / 2
            ? $item[0].offsetLeft - this.contentWidth / 2
            : 0
        if (scrollLeft !== this.left) {
          this.$content.css('transform', 'translateX(-' + scrollLeft + 'px)')
        }
        if (scrollLeft > 0) {
          this.$prev.show()
        } else {
          this.$prev.hide()
        }
        if (scrollLeft + this.contentWidth > this.$content[0].scrollWidth) {
          this.$next.hide()
        } else {
          this.$next.show()
        }
      }
      if (this.autoScroll) {
        if ($item[0].offsetLeft < this.maxScrollLeft) {
          this.$head[0].scrollLeft = $item[0].offsetLeft
        } else {
          this.$head[0].scrollLeft = this.maxScrollLeft
        }
      }
      this.$line.width($item.outerWidth())
      this.$line.css('transform', 'translateX(' + this.distance[index] + 'px)')
      this.$element.find('.vego-tab-content-item').hide().eq(index).show()
      this.$element.trigger('change.vegotab', index)
    }

    Tabs.prototype.getTabHead = function(index) {
      return this.$element
        .find('.vego-tab--item')
        .eq(index)
    }

    function ResizeVideo() {
      this.run = function () {
        $('.video').each(function (i, v) {
          $(v).find('iframe').height($(v).closest('.media').outerHeight())
        })
      }
      $(window).resize(() => {
        this.run()
      })
      this.run()
    }

    $(function () {
      function relayout() {
        var $a = $('.page-content--product .yotpo.bottomLine a.text-m')
        if ($a.length) {
          $a.each(function () {
            $(this).text(' (' + $(this).text() + ')')
            $(this)
              .closest('.yotpo-bottomline')
              .find('.sr-only')
              .prependTo($(this))
          })
        } else {
          setTimeout(relayout, 1000)
        }
      }
      if ($('.page-content--product').length) {
        relayout()
      }
      setTimeout(function () {
        new Tabs({
          wrapName: '#configurations-tab',
          linePosition: 'none'
        })
        new Tabs({
          wrapName: '#configurations-tab-0',
          linePosition: 'none'
        })
        new Tabs({
          wrapName: '#configurations-tab-1',
          linePosition: 'none'
        })
        new Tabs({
          wrapName: '#configurations-tab-2',
          linePosition: 'none'
        })
        new Tabs({
          wrapName: '#configurations-tab-3',
          linePosition: 'none'
        })
        $('#configurations-tab').on('change.vegotab', function(e) {
          $('.plants-slider').slick('slickSetOption', '', '', true)
        })
      }, 1000)

      $('.activity-tabs').each(function() {
        new Tabs({
          element: this,
          linePosition: 'none',
          autoScroll: true
        })
      })
      
      new ResizeVideo()
      $('.media .media-btn').on('click', function () {
        $(this).siblings('.thumbnail').remove().end().remove()
      })

      var $items = $('.assembly-container .assembly-item')
      if ($items.length > 0) {
        $items.find('.a2').each(function () {
          var html = ''
          $(this)
            .closest('.a1')
            .find('.a3')
            .each(function () {
              html += $(this).html() + ' '
            })
          if (html.trim()) {
            var $tooltip = $(
              '<span class="a4" data-toggle="tooltip" data-arrow title="" ><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6.25" stroke="#93816E" stroke-width="1.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09073 4.90998C7.59281 4.90998 7.99982 4.50296 7.99982 4.00089C7.99982 3.49881 7.59281 3.0918 7.09073 3.0918C6.58865 3.0918 6.18164 3.49881 6.18164 4.00089C6.18164 4.50296 6.58865 4.90998 7.09073 4.90998ZM7.09073 5.81836C6.58865 5.81836 6.18164 6.22537 6.18164 6.72745V9.63654C6.18164 10.1386 6.58865 10.5456 7.09073 10.5456C7.59281 10.5456 7.99982 10.1386 7.99982 9.63654V6.72745C7.99982 6.22537 7.59281 5.81836 7.09073 5.81836Z" fill="#93816E"/></svg></span>'
            )
            $tooltip.attr('title', html)
            $(this).append($tooltip)
          }
          if ($(this).text() == 'User Manual' && (!$(this).next('a').attr('href') || $(this).next('a').attr('href') == 'javascript:void(0)')) {
            $(this).closest('.assembly-item').hide()
          }
        })
        $items.find('.a1[data-variant]').each(function() {
          const variantId = $(this).data('variant')
          $(this).closest('.assembly-item').data('variant', variantId).addClass('hide')
          const currentVariant = theme.getCurrentProductVariant()
          if (currentVariant && currentVariant.id == variantId) {
            $(this).closest('.assembly-item').removeClass('hide')
          }
        })
        $('[data-toggle="tooltip"]').tooltip()
        
      }
    })
  })(jQuery)
  ; +(function () {
    function Collapse(element, options) {
      this.$element = $(element)
      this.$content = this.$element
        .closest('.vego-collapse')
        .children('.vego-collapse-item')
      this.isShow = false
      this.transitioning = null
      this.$parent = this.getParent()
    }

    Collapse.prototype.show = function () {
      if (this.transitioning || this.isShow) return

      var actives =
        this.$parent &&
        this.$parent
          .find('.vego-collapse-item.in, .vego-collapse-item.collapsing')
          .closest('.vego-collapse')
          .find('.vego-collapse-trigger')

      if (actives && actives.length) {
        var activesData = actives.data('vego.collapse')
        if (activesData && activesData.transitioning) return
        Plugin.call(actives, 'hide')
      }

      this.$content.addClass('collapsing').height(0)

      this.transitioning = 1

      var complete = function () {
        this.$content.removeClass('collapsing').addClass('in').height('')
        this.transitioning = 0
        this.isShow = true
      }

      var scrollSize = this.$content[0].scrollHeight
      this.$content
        .one('transitionend', $.proxy(complete, this))
        .height(scrollSize)
    }

    Collapse.prototype.hide = function () {
      if (this.transitioning || !this.isShow) return

      this.$content.height(this.$content[0].offsetHeight)

      this.$content.addClass('collapsing').removeClass('in')

      this.transitioning = 1

      var complete = function () {
        this.transitioning = 0
        this.$content.removeClass('collapsing').height('')
        this.isShow = false
      }

      this.$content.height(0).one('transitionend', $.proxy(complete, this))
    }

    Collapse.prototype.toggle = function () {
      this[this.isShow ? 'hide' : 'show']()
    }

    Collapse.prototype.getParent = function () {
      return this.$element.closest('.vego-tab-content-item')
    }

    // COLLAPSE PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
      return this.each(function () {
        var $this = $(this)
        var data = $this.data('vego.collapse')
        if (!data)
          $this.data('vego.collapse', (data = new Collapse(this, option)))
        if (typeof option == 'string') data[option]()
      })
    }

    var old = $.fn.collapse

    $.fn.collapse = Plugin
    $.fn.collapse.Constructor = Collapse

    // COLLAPSE NO CONFLICT
    // ====================

    $.fn.collapse.noConflict = function () {
      $.fn.collapse = old
      return this
    }
    $(document).on(
      'click.vego.collapse',
      '[data-toggle="collapse"]',
      function (e) {
        var $this = $(this)
        var $trigger = $this.find('.vego-collapse-trigger')

        Plugin.call($trigger, 'toggle')
      }
    )
  })()
  ; +(function ($) {
    const DEFAULT_OPTIONS = {
      moreText: 'Read more',
      lessText: 'Read less',
      btnbg: '',
      line: 4,
      hideLess: false
    }
    function TextFolder(element, options) {
      this.$ele = $(element)
      this.options = $.extend(true, {}, DEFAULT_OPTIONS, options);
      if (!this.options.height) {
        var style = window.getComputedStyle(element, null);
        var fontSize = style.fontSize;
        var lineHeight = style.lineHeight === "normal" ? fontSize : style.lineHeight;
        this.lineHeight = Number(lineHeight.replace('px', ''))
      }
      this.folding = false
      this.init()
    }

    TextFolder.prototype.init = function () {
      var that = this
      if (!this.options.height) {
        this.lines = this.$ele.height() / this.lineHeight
        if (this.lines > this.options.line) {
          this.folding = true
        }
      } else {
        if (this.$ele.height() > this.options.height) {
          this.folding = true
        }
      }

      if (this.folding) {
        if (this.options.btnUp) {
          this.$btn = $([this.options.btnUp[0], this.options.btnDown[0]])
        } else {
          this.$btn = $('<span class="folding-btn folding-more">' + this.options.moreText + '</span>')
          this.$ele.append(this.$btn)
          if (this.options.btnbg) {
            this.$btn.css('background-color', this.options.btnbg)
          }
        }
        this.fold()
        this.$btn.on('click', function () {
          if (that.folding) {
            that.$ele.removeClass('text-folding')
            that.$ele.css('max-height', 'none')
            if (that.options.btnUp) {
              that.options.btnDown.css('display', 'none')
              that.options.btnUp.css('display', 'flex')
            } else {
              if (that.options.hideLess) {
                that.$btn.remove()
              } else {
                that.$btn.text(that.options.lessText).removeClass('folding-more').addClass('folding-less')
              }
            }
            that.$ele.data('scrollTop', $(window).scrollTop())
          } else {
            if (that.options.btnUp) {
              that.options.btnDown.css('display', 'flex')
              that.options.btnUp.css('display', 'none')
            } else {
              that.$btn.text(that.options.moreText).removeClass('folding-less').addClass('folding-more')
            }

            that.fold()
            if (that.options.restore) {
              $(window).scrollTop(that.$ele.data('scrollTop'))
            }
          }
          that.folding = !that.folding
        })
      }
    };

    TextFolder.prototype.fold = function () {
      this.$ele.addClass('text-folding')
      if (this.options.height) {
        this.$ele.css('max-height', this.options.height + 'px')
      } else {
        this.$ele.css('max-height', this.lineHeight * this.options.line + 'px')
      }
    }

    jQueryBridget('textFolder', TextFolder);

  })(jQuery)
  ; +(function ($) {
    'use strict'

    // PriceRange CLASS DEFINITION
    // ====================  
    var PriceRange = function (element) {
      this.element = $(element)
      this.options = {
        min: this.element.data('min') || 0,
        max: this.element.data('max')
      }
      this.priceInput = this.element.find('.price-range__input')
      this.init()
    }

    PriceRange.prototype.init = function () {
      this.onPriceChange = this.onPriceChange.bind(this)
      this.priceInput.on('change', this.onPriceChange)
    }

    PriceRange.prototype.destroy = function () {
      this.priceInput.off('change', this.onPriceChange)
      this.element.removeData('pricerange')
    }

    PriceRange.prototype.onPriceChange = function (e) {
      e.preventDefault()
      var event = $.Event('priceChange.vego')
      event.target = this.element[0]
      this.element.trigger(event)
    }

    jQueryBridget('pricerange', PriceRange)
  })(jQuery)
  ; +(function ($) {
    var CollectionFilterV2 = function (ele) {
      var _this = this
      this.$ele = $(ele)
      this.sectionId = this.$ele.attr('section-id')
      this.onFieldChange = this.onFieldChange.bind(this)
      this.$ele.find('.price-range-filter').pricerange().on('priceChange.vego', this.onFieldChange)
      this.$ele.on('change', 'input[type=checkbox]', function (e) {
        if (!this.name.startsWith("filter."))
          return;
        _this.onFieldChange(e);
      })
      this.$ele.closest('.collection-container').on('change', '#SortBy', function (e) {
        var qs = $.qs()
        qs['sort_by'] = this.value
        _this.renderPage($.param(qs, true))
      })
      this.initCollapse()
      this.closeDrawer = this.closeDrawer.bind(this)
      this.$ele.find('.collection-filter-drawer-overlay').on('click', this.closeDrawer)
      this.$ele.find('.filters-mobile-header .vegoicon').on('click', this.closeDrawer)
      this.$ele.closest('.collection-container').on('click', '.collection-filter__filter', function () {
        _this.$ele.find('.collection-filters-mobile > div').show()
        setTimeout(function () {
          _this.$ele.find('.collection-filters-mobile').addClass('open')
        }, 100)
      })
    }

    CollectionFilterV2.prototype.closeDrawer = function () {
      var _this = this
      _this.$ele.find('.collection-filters-mobile').removeClass('open')
      setTimeout(function () {
        _this.$ele.find('.collection-filters-mobile > div').hide()
      }, 300)
    }

    CollectionFilterV2.prototype.initCollapse = function () {
      var $actives = this.$ele.find('.filter-form-item.active')
      if ($actives.length) {
        $actives.closest('.collection-filter').addClass('open')
      }
      this.$ele.on('click', '.collection-filter__label', function (e) {
        e.preventDefault()
        $(this).closest('.collection-filter').toggleClass('open')
      })
    }

    CollectionFilterV2.prototype.onFieldChange = function (e, searchParam) {
      $(e.target).closest('.filter-form-item').toggleClass('active')
      var query = $(e.target).closest("form").find(":input").filter(function (index, element) {
        return $(element).val() != '';
      }).serialize()
      var searchParams = new URLSearchParams(query)
      var currentQuery = $.qs()
      var keys = ['type', 'q']
      keys.forEach(e => {
        if (currentQuery[e]) {
          searchParams.set(e, currentQuery[e][0])
        }
      });
      this.renderPage(searchParams.toString())
    }

    CollectionFilterV2.prototype.renderPage = async function (searchParams) {
      const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
      this.$ele.closest('.collection-container').attr('loading', 'true')
      const response = await fetch(url);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      if (!html.querySelector(".product-grid-empty")) {
        this.$ele.closest('.collection-container').find('.collection-products').html(
          $(html).find('.collection-products').html())
        $.$$updateInput()
        $('select.grid-product-variant-input:enabled').vselect()
        $('[data-ui="select"]').vselect()
        $('.grid-product').collecionProduct()
        $('[data-toggle="tooltip"]').tooltip()
        this.$ele.find('#FiltersFormLarge .collection-filter').each(function () {
          if ($(this).hasClass('open')) {
            const filter = $(this).data('filter')
            const filterTemp = $(html).find('#FiltersFormLarge .collection-filter[data-filter="' + filter + '"]')
            filterTemp.addClass('open')
          }
        })
        this.$ele.find('.collection-filter-drawer-overlay').off('click', this.closeDrawer)
        this.$ele.find('.filters-mobile-header .vegoicon').off('click', this.closeDrawer)
        this.$ele.find('.price-range-filter').pricerange('destroy').off('priceChange.vego', this.onFieldChange)
        theme.countdown('destory')
        this.$ele.find('.collection-filters-mobile').html($(html).find('.collection-filters-mobile').html())
        $('.filters-mobile-footer').html($(html).find('.filters-mobile-footer').html())
        if (this.$ele.find('.collection-filters-mobile').hasClass('open')) {
          this.$ele.find('.collection-filters-mobile > div').show()
        }
        history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
        this.$ele.find('.price-range-filter').pricerange().on('priceChange.vego', this.onFieldChange)
        this.$ele.find('.collection-filter-drawer-overlay').on('click', this.closeDrawer)
        this.$ele.find('.filters-mobile-header .vegoicon').on('click', this.closeDrawer)
        $.$$rePositionCollectionBanner(3, '.collection-container .collection-products')
        window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets && window.yotpoWidgetsContainer.initWidgets()
        theme.countdown()
      } else {
        this.$ele.closest('.collection-container').find('#FilterProductCount').hide()
        this.$ele.closest('.collection-container').find('.grid-product__group').html($(html).find('.product-grid-empty').html())
      }
      AOS.refreshHard()
      theme.bgsetInit()
      this.$ele.closest('.collection-container').removeAttr('loading')
    }
    jQueryBridget('filterV2', CollectionFilterV2)

    $('.collection-filters').filterV2()
  })(jQuery);
; +(function ($) {
    var CollectionFilterV3 = function (ele) {
      var _this = this
      this.$ele = $(ele)
      this.sectionId = this.$ele.attr('section-id')
      this.lastQuery = location.search.split('?')[1] || ''
      this.onFieldChange = this.onFieldChange.bind(this)
      this.collapse = false
      this.$ele.on('click', '.collection-filter-tag', this.onFieldChange)
      this.$ele.find('.price-range-filter').pricerange().on('priceChange.vego', this.onFieldChange)
      this.$ele.on('change', 'input[type=checkbox]', function (e) {
        if (!this.name.startsWith("filter."))
          return;
        _this.onFieldChange(e);
      })
      this.$ele.on('click', '.pagination a', function(e) {
        e.preventDefault()
        var $link = $(e.target).closest('a')
        var href = $link.attr('href')
        var query = href.split('?')[1]
        if (query) {
          _this.renderPage(query)
          _this.scrollToTop()
        }
      })
      $('.anchor-link').each(function() {
        $(this).on('click', function(e) {
          e.preventDefault()
          var href = $(this).attr('href')
          var query = href.split('?')[1]
          var tabIndex = $(this).data('tab')
          if (query) {
            _this.scrollToTop()
            if (!tabIndex) {
              tabIndex = 0
            } else {
              tabIndex = +tabIndex
            }
            _this.renderPage(query, tabIndex)
          }
        })
      })
      $('.filter-bar .title').on('click', function(){
        if (_this.collapse) {
          $('.filter-bar').removeClass('collapse')
          _this.$ele.find('.activity-tabs').show()
          _this.collapse = false
        } else {
          $('.filter-bar').addClass('collapse')
          _this.$ele.find('.activity-tabs').hide()
          _this.collapse = true
        }
      })
      $('.filter-bar .collection-filter-clearall').on('click', function(event) {
        event.preventDefault()
        _this.renderPage('')
      })
      this.toggleClearAll()
      // this.lastTab = 0
      // $('.activity-tabs').on('change.vegotab', function(e, index) {
      //   if (_this.lastTab !== index && _this.lastQuery !== '' && index < 3) {
      //     _this.$ele.find('.vego-tab-content-item-types .collection-filter-tag').each(function() {
      //       $(this).removeClass('active')
      //     })
      //     _this.renderPage('')
      //   }
      //   _this.lastTab = index
      // })
    }

    CollectionFilterV3.prototype.toggleClearAll = function() {
      var $clearall = this.$ele.find('.collection-filter-clearall')
      const queryParams = this.getQueryParams()
      var queryCounts = 0
      Object.keys(queryParams).forEach(function(key) {
        queryCounts += queryParams[key].length
      })
      if (queryCounts > 0) {
        $clearall.removeClass('hide')
        $clearall.find('.collection-filter-clearall-num').text(queryCounts)
      } else {
        $clearall.addClass('hide')
      }
    }

    CollectionFilterV3.prototype.scrollToTop = function() {
      var top = $('.collection-filters-v3').offset().top
      window.scrollTo({
        top: top - (theme.isMobile() ? ($('.header-search-v2').hasClass('site-header--stuck') ? 268 : 398) : ($('.header-search-v2').hasClass('site-header--stuck') ? 218 : 369)),
        behavior: 'smooth'
      })
    }

    CollectionFilterV3.prototype.getQueryParams = function() {
      var queryParams = {}
      function addQueryParams(key, value) {
        if (queryParams[key]) {
          queryParams[key].push(value)
        } else {
          queryParams[key] = [value]
        }
      }
      var $activeFilterTags = $('.collection-filter-tags .active')
      if ($activeFilterTags.length) {
        $activeFilterTags.each(function() {
          addQueryParams($(this).data('name'), $(this).data('value'))
        })
      }
      this.$ele.find('.vego-tab-content-item input').each(function() {
        var $input = $(this)
        if ($input.is('[type=checkbox]')) {
          if ($input.prop('checked')) {
            addQueryParams($input.attr('name'), $input.val())
          }
        } else {
          if ($input.val() != '') {
            addQueryParams($input.attr('name'), $input.val())
          }
        }
      })
      var currentQuery = $.qs()
      var keys = ['type', 'q']
      keys.forEach(e => {
        if (currentQuery[e]) {
          queryParams[e] = currentQuery[e][0]
        }
      });
      return queryParams
    }

    CollectionFilterV3.prototype.onFieldChange = function (e, searchParam) {
      var $currentFilterTag = $(e.target).closest('.collection-filter-tag')
      $currentFilterTag.toggleClass('active')
      const queryParams = this.getQueryParams()
      this.renderPage.call(this, $.param(queryParams, true))
    }

    CollectionFilterV3.prototype.renderPage = async function (searchParams, previousIndex) {
      this.lastQuery = searchParams
      const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
      this.$ele.closest('.collection-filters-v3').attr('loading', 'true')
      const response = await fetch(url);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      if (!html.querySelector(".product-grid-empty")) {
        this.$ele.find('.collection-products').html($(html).find('.collection-products').html())
        $.$$updateInput()
        $('select.grid-product-variant-input:enabled').vselect()
        $('[data-ui="select"]').vselect()
        $('.grid-product').collecionProduct()
        $('[data-toggle="tooltip"]').tooltip()
        var tabsInstance = $('.activity-tabs').data('vego.tabs')
        var previousHead
        if (previousIndex == undefined) {
          previousHead = tabsInstance.getTabHead(tabsInstance.currentIndex)
        }
        var tabScrollLefts = []
        this.$ele.find('.vego-tab-content-item-types').each(function() {
          var scrollLeft = $(this).find('.collection-filter-tags')[0].scrollLeft
          tabScrollLefts.push(scrollLeft)
        })
        this.$ele.find('.price-range-filter').pricerange('destroy').off('priceChange.vego', this.onFieldChange)
        theme.countdown('destory')
        this.$ele.find('.activity-tabs').html($(html).find('.activity-tabs').html())
        
        if (previousHead) {
          previousIndex = this.$ele.find('.activity-tabs').find('.vego-tab--item').index($('#' + previousHead.attr('id')))
        }
        tabsInstance.init()
        tabsInstance.setTab(previousIndex)
        this.$ele.find('.vego-tab-content-item-types').each(function(i) {
          $(this).find('.collection-filter-tags')[0].scrollLeft = tabScrollLefts[i] || 0
        })
        history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
        this.$ele.find('.price-range-filter').pricerange().on('priceChange.vego', this.onFieldChange)
        window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets && window.yotpoWidgetsContainer.initWidgets()
        theme.countdown()
        this.toggleClearAll()
      } else {
        this.$ele.find('.collection-products').html($(html).find('.product-grid-empty').html())
      }
      AOS.refreshHard()
      theme.bgsetInit()
      setupEventListeners();
      this.$ele.closest('.collection-filters-v3').removeAttr('loading')
    }
    jQueryBridget('filterV3', CollectionFilterV3)

    $('.collection-filters-v3').filterV3()
  })(jQuery);

; +(function ($) {
  function ChooseSelect(ele) {
    this.$ele = $(ele)
    this.initEvent()
  }
  ChooseSelect.prototype.initEvent = function () {
    let _this = this
    // this.$ele.find('.grid-configs-assemble .grid-config').each(function(){
    //   $(this).hide()
    // })
    this.$ele.find('.choose-select .choose-select-con').html(this.$ele.find('.choose-select-option.active').text())
    this.$ele.find('.choose-data-flex').each(function () {
      $(this).hide()
      if (_this.$ele.find('.choose-select-option.active').text() == $(this).find('.choose-order').text().trim()) {
        $(this).show()
      }
    })
    this.$ele.find('.choose-select').on('click', function () {
      $(this).toggleClass('open')
      _this.$ele.find('.choose-select-option-all').toggle()
    })
    this.$ele.find('.choose-select-option').on('click', function () {
      _this.$ele.find('.choose-select').toggleClass('open')
      _this.$ele.find('.choose-select-option').each(function () {
        $(this).removeClass('active')
      })
      $(this).addClass('active')
      _this.$ele.find('.choose-data-flex').each(function () {
        $(this).hide()
        if (_this.$ele.find('.choose-select-option.active').text() == $(this).find('.choose-order').text().trim()) {
          $(this).show()
        }
      })
      $(this).closest('.choose-select-option-all').hide()
      _this.$ele.find('.choose-select .choose-select-con').html($(this).text())
    })
  }
  jQueryBridget('chooseSelect', ChooseSelect)
  $('.choose-content').chooseSelect()
})(jQuery)
  ; +(function () {
    function CollectionFilter(ele) {
      var that = this
      this.$ele = $(ele)
      this.currentTags = []
      this.tags = {}
      this.$ele.find('.filter__option').each(function () {
        var info = {
          ele: this,
          count: 0,
          title: $(this).find('.filter-title').text()
        }
        var tag = $(this).data('tag')
        that.tags[tag] = info
      })
      this.size = {}
      this.stock = []
      var queryParams = this.queryParams = $.qs()
      if (queryParams.width) {
        this.size.width = queryParams.width[0].split('+')
      }
      if (queryParams.length) {
        this.size.length = queryParams.length[0].split('+')
      }
      if (queryParams.filter) {
        var tags = (this.currentTags = queryParams.filter[0].split('+'))
        for (var key in this.tags) {
          if (tags.includes(key)) {
            this.toggleHighlight(this.tags[key].ele)
          }
        }
      }
      if (queryParams.sort_by) {
        this.sortBy = queryParams.sort_by[0]
      }
      this.stock = ['in', 'out']
      this.initial = true
      this.initEvents()
      this.filter()
    }

    CollectionFilter.prototype.initStock = function () {
      var instockCount = 0, outstockCount = 0
      $('.garden-beds-filter-content .grid-product').each(function () {
        if ($(this)[0].getAttribute('cross-border-show') != 'hide') {
          if ($(this).data('instock')) {
            instockCount++
          } else {
            outstockCount++
          }
        }
      })
      $('#in-count').text(instockCount)
      $('#out-count').text(outstockCount)
    }

    CollectionFilter.prototype.initEvents = function () {
      var that = this
      this.$ele.on('click', '.filter__option', function () {
        that.change(this)
      })
      $('.collection-filter__filter').on('click', function () {
        if ($(this).hasClass('active')) {
          that.$ele.hide()
          $('.garden-beds-filter-content').hide()
          $('.garden-beds-content').show()
        } else {
          that.$ele.show()
          $('.garden-beds-filter-content').show()
          $('.garden-beds-content').hide()
        }
        $(this).toggleClass('active')
      })
      $('input[name=availablity]').on('change', function () {
        if ($(this).prop('checked')) {
          that.stock.push($(this).val())
        } else {
          that.stock.splice(that.stock.indexOf($(this).val()), 1)
        }
        that.filter()
      })
      this.$ele.find('.collapse-drop > span').on('click', function () {
        if (that.$ele.hasClass('collapse')) {
          that.$ele.removeClass('collapse')
          $(this).text('Less')
          $(this).next('svg').css('transform', 'rotate(180deg)')
        } else {
          that.$ele.addClass('collapse')
          $(this).text('More')
          $(this).next('svg').css('transform', 'none')
        }
      })
    }

    CollectionFilter.prototype.change = function (ele) {
      var $active = $(ele)
        .closest('.filter__options')
        .find('.filter__option.active')
      if ($active.length) {
        this.toggleHighlight($active[0])
        this.currentTags.splice(this.currentTags.indexOf($active.data('tag')), 1)
      }
      if ($active[0] == ele) {
        this.filter()
        return
      }
      this.toggleHighlight(ele)
      this.currentTags.push($(ele).data('tag'))
      this.filter()
    }

    CollectionFilter.prototype.toggleHighlight = function (ele) {
      $(ele).toggleClass('active')
      $(ele).find('img').toggleClass('active')
    }

    CollectionFilter.prototype.inTag = function (tags) {
      for (var i = 0; i < this.currentTags.length; i++) {
        if (tags.indexOf(this.currentTags[i]) == -1) {
          return false
        }
      }
      return true
    }

    CollectionFilter.prototype.inSize = function (value, range) {
      if (!range) {
        return true
      }
      if (!value) {
        return false
      }
      var sizes = (value + '').split(',')
      var min = +range[0],
        max = +range[1]
      for (var i = 0; i < sizes.length; i++) {
        var v = +sizes[i]
        if (v >= min && v <= max) {
          return true
        }
      }
      return false
    }

    CollectionFilter.prototype.inStock = function (value, stock) {
      for (var i = 0; i < stock.length; i++) {
        var s = stock[i];
        if (s == 'in' && value) {
          return true;
        } else if (s == 'out' && !value) {
          return true
        }
      }
      return false
    }

    CollectionFilter.prototype.makeQuery = function (key, value) {
      if (value && value.length) {
        this.queryParams[key] = [value.join('+')]
      } else {
        delete this.queryParams[key]
      }
    }

    CollectionFilter.prototype.hasQuery = function () {
      return (
        this.currentTags.length ||
        (this.size.width && this.size.width.length) ||
        (this.size.length && this.size.length.length) || this.sortBy
      )
    }

    CollectionFilter.prototype.filter = function () {
      var that = this
      this.makeQuery('filter', this.currentTags)
      this.makeQuery('width', this.size.width)
      this.makeQuery('length', this.size.length)

      for (var k in this.tags) {
        this.tags[k].count = 0
      }
      if (this.initial && this.hasQuery() || !this.initial) {
        $('.garden-beds-content').hide()
        $('.collection-filter__filter').addClass('active')
        $('.garden-beds-filter-content').show()
        this.$ele.show()
      }

      var count = 0, instockCount = 0, outstockCount = 0
      $('.garden-beds-filter-content .grid-product').each(function () {
        var tags = $(this).data('tags')
        var width = $(this).data('width')
        var length = $(this).data('length')
        var stock = $(this).data('instock')
        var show = false
        if (that.inStock(stock, that.stock)) {
          if (that.hasQuery()) {
            if (
              that.inTag(tags) &&
              that.inSize(width, that.size.width) &&
              that.inSize(length, that.size.length)
            ) {
              show = true
            }
          } else {
            show = true
          }
        }
        if (show) {
          count++
          $(this).show()
          for (var k in that.tags) {
            if (tags.includes(k)) {
              that.tags[k].count++
            }
          }
          if (stock) {
            instockCount++
          } else {
            outstockCount++
          }
        } else {
          $(this).hide()
        }
      })
      $('#in-count').text(instockCount)
      $('#out-count').text(outstockCount)
      $('.garden-beds-filter-content .grid-title-count').text(count + ' Result' + (count > 1 ? 's' : ''))
      for (var k in this.tags) {
        var info = this.tags[k]
        $(info.ele).find('.filter-title').text(info.title + ' (' + info.count + ')')
      }
      $('.grid-product-variant-input:hidden')
        .not('.vego-select-contaner select')
        .prop('disabled', true)
      $('.grid-product-variant-input:visible').prop('disabled', false)
      $('select.grid-product-variant-input:enabled').vselect()
      if (!this.initial) {
        window.history.pushState(
          {},
          {},
          location.pathname + (!!Object.keys(this.queryParams).length ? ('?' + $.param(this.queryParams, true)) : '')
        )
      }
      this.initial = false
    }

    function applyFilter(ele) {
      var stock = ['in', 'out']
      var parent = $(ele)
      var collectionContent, countContent, isAddon = false
      if (parent.hasClass('collection-addon-filter')) {
        isAddon = true
      }
      if (parent.data('target')) {
        collectionContent = $('#' + parent.data('target'))
        countContent = $('.grid-title-count[data-target=' + parent.data('target') + ']')
      } else {
        if (isAddon) {
          collectionContent = parent.parents('.page-section').find('.grid-collection')
        } else {
          collectionContent = $('.grid-collection')
        }
        countContent = $('.grid-title-count')
      }
      function init() {
        var instockCount = 0, outstockCount = 0
        collectionContent.find('.grid-product').each(function () {
          if ($(this)[0].getAttribute('cross-border-show') != 'hide') {
            if ($(this).data('instock')) {
              instockCount++
            } else {
              outstockCount++
            }
          }
        })
        $('#in-count').text(instockCount)
        $('#out-count').text(outstockCount)
      }
      init()
      function filter() {
        var count = 0;
        collectionContent.find('.grid-product').each(function () {
          if ($(this)[0].getAttribute('cross-border-show') != 'hide') {
            var instock = $(this).data('instock');
            if ((instock && stock.indexOf('in') > -1) || (!instock && stock.indexOf('out') > -1)) {
              if (filterTags.length) {
                var tags = $(this).data('tags')
                var hasTag = false
                for (var i = 0; i < filterTags.length; i++) {
                  var t = filterTags[i]
                  if (tags.indexOf(t) > -1) {
                    hasTag = true
                    break
                  }
                }
                if (hasTag) {
                  count++
                  $(this).show()
                } else {
                  $(this).hide()
                }
              } else {
                count++
                $(this).show()
              }
            } else {
              $(this).hide()
            }
          }
        })
        countContent.text(count + ' Products')
        if (isAddon) {
          countContent.removeClass('hide')
          collectionContent.removeClass('hide')
          $('.page-collection-content').addClass('hide')
        }
      }
      $('input[name=availablity]').on('change', function () {
        if ($(this).prop('checked')) {
          stock.push($(this).val())
        } else {
          stock.splice(stock.indexOf($(this).val()), 1)
        }
        filter()
      })
      var filterTags = []
      $('input[name=category]').on('change', function () {
        if ($(this).prop('checked')) {
          filterTags.push($(this).val())
        } else {
          filterTags.splice(filterTags.indexOf($(this).val()), 1)
        }
        filter()
      })
    }

    function rePositionCollectionBanner(perRow = 4, root) {
      if (theme.settings.collectionBannerIndex) {
        var bannerIndex = +theme.settings.collectionBannerIndex
        var rownum = Math.round(bannerIndex / perRow)
        var mod = bannerIndex % perRow
        if (theme.isMobile()) {
          perRow = 2
          bannerIndex = 2 * rownum + mod
        }
        if (!root || !$(root).length) {
          return
        }
        var children = $(root).find('.grid-product__group').children(':visible')
        if (children.length && !$(children[0]).hasClass('collection-promotion-banner')) {
          $(root).find('.grid-product__group .collection-promotion-banner').each(function () {
            var _this = this
            if (mod == 1) {
              var height = 0
              var observer = new MutationObserver(function (mutations, observer) {
                if (children.find('.grid-product__box').height() !== height) {
                  $(_this).css('min-height', children.find('.grid-product__box').height() + 'px')
                  height = children.find('.grid-product__box').height()
                } else {
                  observer.disconnect()
                }
              })
              observer.observe(children[0], {
                childList: false, // 子节点的变动（新增、删除或者更改）
                attributes: true, // 属性的变动
                characterData: false, // 节点内容或节点文本的变动
                subtree: false // 是否将观察器应用于该节点的所有后代节点
              })
            }
            var index = children.index($(this))
            if (index === bannerIndex - 1) {
              return
            }
            if (children.length > bannerIndex) {
              $(children.get(bannerIndex)).before(this)
            } else {
              if (!$(children.get(children.length - 1)).is('.collection-promotion-banner')) {
                $(children.get(children.length - 1)).after($(this))
              }
            }
          })
        }
      }
    }

    $.$$rePositionCollectionBanner = rePositionCollectionBanner

    var sectionFade = {
      init: function () {
        var _this = this;
        this.elements = []
        if ($('.fade-in-section').length) {
          $('.fade-in-section').each(function () {
            _this.elements.push({
              ele: $(this),
              show: false
            })
          })
          $(window).on('scroll', this.spy.bind(this))
        }
      },
      spy: function () {
        var scrollY = window.scrollY || window.pageYOffset
        var clientHeight = window.innerHeight || document.documentElement.clientHeight
        var viewTop = scrollY + clientHeight
        this.elements.forEach((item) => {
          if (!item.show) {
            var offsetTop = item.ele.offset().top
            var bottom = offsetTop + item.ele.height()
            if (offsetTop <= viewTop && bottom >= scrollY) {
              item.ele.css('opacity', 0)
              item.ele.css('visibility', 'visible')
              setTimeout(() => {
                item.ele.css('opacity', 1)
              }, 0)
              item.show = true
            }
          }
        })
      }
    }

    var saleSpy = {
      init: function(elements) {
        var _this = this
        _this.targets = []
        _this.elements = elements
        if (elements.length) {
          _this.first = elements[0]
          _this.last = elements[elements.length - 1]
          this.spy()
        }
      },
      spy: function() {
        var _this = this
        $(window).on('scroll', this.process.bind(this))
        this.elements.on('click', function() {
          let offsetTop = _this.targetOffsetTop($(this))
          var scrollY = window.scrollY || window.pageYOffset
          if (offsetTop > scrollY) {
            offsetTop = offsetTop + 120
          }
          window.scrollTo({
            left: 0,
            top: offsetTop,
            behavior: 'smooth'
          })
        })
      },
      targetOffsetTop ($ele) {
        const id = $ele.data('target')
        if ($('#' + id).length) {
          var offset = $('#' + id).offset()
          const offsetTop = offset.top - 180
          return offsetTop
        }
        return 0
      },
      targetHeight ($ele) {
        const id = $ele.data('target')
        if ($('#' + id).length) {
          return $('#' + id).closest('.labor-day-sale-main-container').height()
        }
        return 0
      },
      process: function() {
        var _this = this
        var scrollY = window.scrollY || window.pageYOffset
        if (scrollY > _this.targetOffsetTop($(_this.first)) + 20) {
          var lastHeight = _this.targetHeight($(_this.last))
          var sidebarHeight = $('.sale-sidebar').outerHeight(true)
          var maxScrollY = _this.targetOffsetTop($(_this.last)) + lastHeight - sidebarHeight - 100
          if (scrollY > maxScrollY) {
            $('.sale-sidebar').addClass('sale-sidebar-bottom')
            $('.sale-sidebar').removeClass('sale-sidebar-sticky')
          } else {
            $('.sale-sidebar').addClass('sale-sidebar-sticky')
            $('.sale-sidebar').removeClass('sale-sidebar-bottom')
          }
        } else {
          $('.sale-sidebar').removeClass('sale-sidebar-sticky')
        }
        let active
        for (var target of _this.elements) {
          if (_this.targetOffsetTop($(target)) + 400 >= scrollY) {
            active = target
            break
          }
        }
        if (active) {
          this.clear()
          $(active).addClass('active')
        }
      },
      clear: function() {
        var _this = this
        _this.elements.removeClass('active')
      }
    }


    $(function () {
      $('.garden-beds-filter').each(function () {
        new CollectionFilter(this)
      })
      $('.grid-head-filter').each(function () {
        applyFilter(this)
      })
      $.$$updateInput()
      $('select.grid-product-variant-input:enabled').vselect()
      $('[data-ui="select"]').vselect()
      $('.grid-product').collecionProduct()
      $('.home-block-feature [data-toggle="tab"]').on(
        'shown.vego.tab',
        function () {
          $('select.grid-product-variant-input:enabled').vselect()
        }
      )
      // collection abtest
      let isGardenBedsPage = window.location.href.indexOf('collections/classic-metal-raised-garden-beds') > -1 || window.location.href.indexOf('collections/garden-beds') > -1
      if (isGardenBedsPage) {
        btnText = `View Product`
        $('.garden-bed-ab-test.ab-test-b').each(function () {
          const $ele = $(this)
          $ele.find('.grid-product-variants').remove()
          $ele.find('.grid-product-est').remove()
          $ele.find('.btn.add-to-cart').replaceWith(`<a type="button" href="${$ele.find('a').attr('href')}" class="btn btn--full btn--secondary add-to-cart" data-uw-rm-form="submit" tabindex="0" aria-label="Button View Product">
            <span> View Product </span>
          </a>`)
        })
        //let url_prefix = theme.isCA()?'/en-ca/products/':'/products/'
        window.addEventListener("storage", (e) => {
          if (e.key == 'card-btn-abtest') {
            if (e.newValue == null) {
              $('.garden-bed-ab-test.ab-test-b').show()
              $('.garden-bed-ab-test.ab-test-a').hide()
            } else {
              $('.garden-bed-ab-test.ab-test-b').hide()
              $('.garden-bed-ab-test.ab-test-a').show()
            }
            $('.slick-slider').slick('refresh')
          }
        });
      }

      rePositionCollectionBanner(4, '.page-collection-section')
      $(
        ".flickity-featured-products:not(.not-slick) .planter-slider-card",
      ).slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000,
      });
      $('.planter-slider-experience').slick(
        {
          arrows: false,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.planter-slider-experience-text',
          responsive: [
            {
              breakpoint: 1921,
              settings: {
                slidesToShow: 1.3,
                slidesToScroll: 1,
                adaptiveHeight: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                prevArrow: '.planter-slick-btns-box .slick-prev',
                nextArrow: '.planter-slick-btns-box .slick-next',
              },
            }
          ],
        }
      )
      $('.planter-slider-experience-text').slick(
        {
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          prevArrow: '.planter-slick-btns-box .slick-prev',
          nextArrow: '.planter-slick-btns-box .slick-next',
          asNavFor: '.planter-slider-experience'
        }
      )

      $('[data-toggle="review"]').on('click', function () {
        var selector = $(this).data('target')
        var top = $(selector).offset().top - 30
        window.scrollTo(0, top)
      })
      $('.grid-head-filter .collection-sort').each(function () {
        $(this).on('change', function () {
          var param = $.qs()
          param.sort_by = $(this).val()
          if (param.page) {
            delete param.page
          }
          window.location.search = $.param(param)
        })
      })
      $('#featured-tab').each(function () {
        $(this).on('change', function (e) {
          var param = $.qs()
          param.sort_by = $(this).val()
          if (param.page) {
            delete param.page
          }
          $(this).closest('.grid-head-top').find(`.vege-nav-tabs a[href="#${param.sort_by.toLowerCase().replace(' ', '-')}"]`).click()
        })
      })

      $('.compare-product-variant .grid-product-variant-input').on(
        'change',
        function () {
          var $option = $(this).find('option:selected')
          var $inner = $(this).closest('.product-compare-column')
          var $form = $(this).closest('form')
          $inner.find('.grid-product__color-image')
            .removeClass('is-active')
            .each(function () {
              if ($(this).data('option1') == $option.data('option1')) {
                $(this).addClass('is-active')
              }
            })
          $inner.find('.compare-price .text-style-3').text($option.data('price'))
          if ($option.data('compareAtPrice') && $option.data('price') != $option.data('compareAtPrice')) {
            // Compare Garden Beds
            $inner.find('.compare-price .text-style-3.product__price--compare').text($option.data('compareAtPrice'))
            let priceStr = parseFloat($option.data('price').replace('$', ''))
            let compareAtPriceStr = parseFloat($option.data('compareAtPrice').replace('$', ''))
            let saving = compareAtPriceStr - priceStr
            $inner.find('.compare-price .bundle-discount-flag').text(`Save $${((saving).toFixed(2))}`)
          } else {
            $inner.find('.compare-price .bundle-discount-flag').text('')
            $inner.find('.compare-price .text-style-3.product__price--compare').text('')
          }

          $inner.find('.grid-product__price--original').text($option.data('compareAtPrice'))
          var $action = $form.find('.grid-product-action')
          $form.find('.gPreorderProperty').remove()
          var isPreOrder = false
          if ($option.data('preorder')) {
            isPreOrder = true
            var fulfillmentTs = $option.data('fulfillmentTs')
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000)
              if (duration < 1296000) {
                isPreOrder = false
              }
            }
          }
          if (isPreOrder) {
            $action.find('.pre-order').removeClass('hide')
            $action.find('.add-to-cart').addClass('hide')
            $form.append(
              '<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Pre-order item">'
            )
            $form
              .find('.gFullfillProperty')
              .val("Ships by: " + $option.data('fulfillment'))
            if (!$form.find('[name="properties[_is_fullfillDate_ts]"]').length) {
              $form.append($(`<input type="hidden"  name="properties[_is_fullfillDate_ts]"  value="${$option.data('fulfillmentTs')}" />`))
            } else {
              $form.find('[name="properties[_is_fullfillDate_ts]"]').val($option.data('fulfillmentTs'))
            }
          } else {
            $action.find('.pre-order').addClass('hide')
            $action.find('.add-to-cart').removeClass('hide')
            $form.find('.gFullfillProperty').val("In Stock")
            $form.find('[name="properties[_is_fullfillDate_ts]"]').remove()

          }
        }
      )
      function resizeBlogFilter() {
        var $expand = $('.blog-tag-filter .blog-tag-expand')
        if ($expand.length > 0) {
          $expand.remove();
        }
        var lastEL, hasMore = false;
        $('.blog-tag-link').each(function (i, e) {
          if (e.offsetTop <= 64) {
            lastEL = e
          } else {
            hasMore = true
          }
        })
        if (hasMore) {
          $expand = $('<span class="blog-tag-link blog-tag-expand"  role="button"  tabindex="0">...</span>');
          $expand.appendTo('.blog-tag-filter')
          var parentWidth = $('.blog-tag-filter')[0].offsetWidth;
          var expandWidth = parseInt($expand.css("marginRight")) + $expand[0].offsetWidth;
          var offset = lastEL.offsetLeft + lastEL.offsetWidth + parseInt($(lastEL).css("marginRight"))
          if (parentWidth >= expandWidth + offset) {
            $expand.insertAfter($(lastEL))
          } else {
            $expand.insertBefore($(lastEL))
          }
        }
      }

      if ($('.blog-tag-filter').length > 0) {
        resizeBlogFilter()
        $('.blog-tag-filter').on('click', '.blog-tag-expand', function (e) {
          $('.blog-tag-filter').css('max-height', 'none')
          $(this).remove()
          $('.blog-tag-filter').addClass('expanded')
        })
        window.on('resize', function () {
          if (!$('.blog-tag-filter').hasClass('expanded')) {
            resizeBlogFilter()
          }
        })
      }

      var cardWidth = document.documentElement.offsetWidth - 36
      $('.affiliate-card-slider--item').width(cardWidth)
      $('.affiliate-slider-card')
        .slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                // variableWidth: true,
                centerMode: true
              },
            }
          ],
        })
      $(window).resize(() => {
        // if(window.location.href.indexOf('giving-back') == -1 || window.location.href.indexOf('school-gardens') == -1)return;
        if ($(window).width() < 768 && (window.location.href.indexOf('giving-back') !== -1 || window.location.href.indexOf('school-gardens') !== -1)) {

          let givingBackWidth = document.documentElement.offsetWidth - 36
          $('.giving-back-rows').width(givingBackWidth)
          $('.giving-back-slider').slick({
            arrows: true,
            draggable: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '.giving-bake-slick-btns-box .slick-prev',
            nextArrow: '.giving-bake-slick-btns-box .slick-next',
          })
        } else {
          $('.giving-back-slider').slick('unslick')
          $('.giving-back-rows').width('auto')
        }
      })

      function applyCollapse(maxHeight) {
        var height = this.offsetHeight
        maxHeight = maxHeight || 80
        if (height > maxHeight) {
          $(this).addClass('collapse')
          $(this).append('<div class="collapse-drop"><span>Read more</span></div>')
        }
      }
      $('.grid-block__meta .grid-block__description, .product-single__meta .product-meta__description').each(function () {
        if ($(this).hasClass('apply-collapse') || theme.isMobile()) {
          var tabs = $(this).find('.vego-tab-pane')
          if (tabs.length > 0) {
            tabs.each(applyCollapse)
          } else {
            applyCollapse.call(this)
          }
          $(this).on('click', '.collapse-drop span', function () {
            $(this).closest('.vego-tab-pane, .product-meta__description').removeClass('collapse')
            $(this).closest('.collapse-drop').remove()
          })
        }
      })
      $('.giving-back-collapse').on('click', '.collapse-drop span', function () {
        $(this).closest('.giving-back-collapse').removeClass('giving-back-collapse')
        $(this).closest('.collapse-drop').remove()
        if ($(window).width() < 768) {
          $('.giving-back-slider').slick('refresh')
        }
      })
      var configItemImageLength = $('.config-all-items .config-item').length
      if (configItemImageLength > 0) {
        var i = 0;
        var collapse = true
        function resolveConfigDrop(img) {
          if ($(img).closest('.config-all-items').attr('role') == 'nocollapse') {
            return
          }
          if (i == configItemImageLength) {
            var height = $('.config-all-items .config-item').outerHeight()
            $('.config-all-items').css('max-height', height + 'px')
            
            $('.config-all-items .config-drop').on('click', function () {
              if (collapse) {
                $(this).closest('.config-all-items').css('max-height', 'none')
                $(this).find('.config-drop-text').text('Less')
                $(this).removeClass('more-drop').addClass('less-drop')
              } else {
                $(this).closest('.config-all-items').css('max-height', height + 100 + 'px')
                $(this).find('.config-drop-text').text('More')
                $(this).removeClass('less-drop').addClass('more-drop')
              }
              collapse = !collapse
            })
          }
          if ($('.tab-discover').length > 0) {
            $('.tab-discover').on('click',function(){
              $('.tab-discover').removeClass('active')
              $(this).addClass('active')
              $('.configurations-tab-discover').hide()
              $('.configurations-tab-discover').find('.config-all-items').css('max-height', 'none')
              $('.configurations-tab-discover').find('.config-drop-text').text('More')
              $('.configurations-tab-discover').find('.config-all-items .config-drop').removeClass('less-drop').addClass('more-drop')
              $(`#${$(this).attr('data-target')}`).show()
              
              $(`#${$(this).attr('data-target')}`).find('.config-all-items').css('max-height', (height ? height:260) + 100 + 'px')
              $(`#${$(this).attr('data-target')}`).find('.config-drop-text').text('More')
              $(`#${$(this).attr('data-target')}`).find('.config-all-items .config-drop').removeClass('less-drop').addClass('more-drop')
              collapse = true
            })
          }
        }
        $('.config-all-items img').each(function () {
          if ($('.discover-our-garden-beds-section').length > 0 ) {
            i++
          }else if(this.complete){
            i++
          }
          
          if (i == configItemImageLength) {
            setTimeout(() => {
              resolveConfigDrop(this)
            }, 1000)
          }
        })
        $('.config-all-items img').on('load', function () {
          i++
          resolveConfigDrop(this)
        })
       
      }



      // $('#configurations-tab .vego-tab-content-item:first-child .lazyload').on('lazyloaded', function() {
      //   var maxHeight = 1.24038462 * $(this).width()
      //   if ($(this).height() > maxHeight) {
      //     var $drop = $('<div class="more-drop"><div><span>More</span><div class="drop--icon"><svg class="vegoicon vegoicon-move-down"><use xlink:href="#vegoicon-move-down"></use></svg></div></div></div>')
      //     var $a3 = $(this).closest('.vego-tab-content-item').find('.a3')
      //     $(this).closest('.vego-tab-content-item').append($drop)
      //     $a3.css('max-height', maxHeight + 'px')
      //     var collapse = true
      //     $drop.on('click', function() {
      //       if (collapse) {
      //         $a3.css('max-height', 'none')
      //         $drop.removeClass('more-drop').addClass('less-drop')
      //         $drop.find('span').text('Less')
      //       } else {
      //         $a3.css('max-height', maxHeight + 'px')
      //         $drop.removeClass('less-drop').addClass('more-drop')
      //         $drop.find('span').text('More')
      //       }
      //       collapse = !collapse
      //     })
      //   }
      // })
      $('[data-popover]').each(function () {
        var target = $('#' + this.dataset.popover)
        var popperInstance = Popper.createPopper(this, target[0], {
          // placement,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8]
                // offset: ({ placement, reference, popper }) => {
                //   console.log(placement, reference, popper);
                //   if (placement === 'bottom') {
                //     return [0, popper.height / 2];
                //   } else {
                //     return [0, 8];
                //   }
                // },
                // fn({ state }) {
                //   const overflow = detectOverflow(state);
                //   console.log(overflow);
                // },
              },
            },
          ],
        })
        $(this).on('click', function () {
          if (target.hasClass('show')) {
            target.removeClass('show')
          } else {
            target.addClass('show')
            popperInstance.update()
          }
        })
      })

      // let father_s_day_config = {
      //   'foodcube-slim': [
      //     {
      //       x: '20.2051%',
      //       y: '68.7031%',
      //       handle: 'foodcube-slim'
      //     },
      //   ],
      //   'elevated-garden-bed-v-series-2-x-4-with-wheels': {
      //     desktop: [

      //       {
      //         x: '50.2051%',
      //         y: '50.7031%',
      //         handle: 'elevated-garden-bed-v-series-2-x-4-with-wheels'
      //       },
      //     ],
      //     mobile: [

      //       {
      //         x: '50.2051%',
      //         y: '50.7031%',
      //         handle: 'elevated-garden-bed-v-series-2-x-4-with-wheels'
      //       },
      //     ],
      //   },
      //   'the-ezcube-planter-21-x-48': [
      //     {
      //       x: '60.2051%',
      //       y: '67.7031%',
      //       handle: 'the-ezcube-planter-21-x-48'
      //     },
      //   ],
      //   'self-watering-rolling-tomato-planter-pot-with-trellis': {
      //     desktop: [
      //       {
      //         x: '20.2051%',
      //         y: '84.7031%',
      //         handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '20.2051%',
      //         y: '74.7031%',
      //         handle: 'the-ezcube-planter-21-x-24'
      //       },
      //     ]
      //   },
      //   'vego-hose-reel-cover': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '54.7031%',
      //         handle: 'vego-hose-reel-cover'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '54.7031%',
      //         handle: 'vego-hose-reel-cover'
      //       },
      //     ]
      //   },
      //   '10-in-1-modular-metal-raised-garden-bed-kit': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '58.2031%',
      //         handle: 'vego-irrigation-kit'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '1.7031%',
      //         handle: 'metal-frame-string-trellis'
      //       },
      //     ]

      //   },
      //   'hi-flow-retractable-hose-reel-set-100': [
      //     {
      //       x: '60.2051%',
      //       y: '34.7031%',
      //       handle: 'hi-flow-retractable-hose-reel-set-100'
      //     },
      //   ],
      //   'hi-flow-retractable-hose-reel-set-100_1': [
      //     {
      //       x: '60.2051%',
      //       y: '52.7031%',
      //       handle: 'ez-self-watering-herb-planter-with-trellis-g2'
      //     }
      //   ],
      //   'elevated-garden-bed-2-by-4': [
      //     {
      //       x: '60.2051%',
      //       y: '34.7031%',
      //       handle: 'elevated-garden-bed-2-by-4'
      //     },
      //   ],
      //   'the-grow-light-garden-series-f4_21': [
      //     {
      //       x: '40.2051%',
      //       y: '4.7031%',
      //       handle: 'the-grow-light-garden-series-f4'
      //     },
      //   ],
      //   'the-grow-light-garden-series-f4_2': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '14.7031%',
      //         handle: 'the-grow-light-garden-series-f4'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '77.7031%',
      //         handle: 'the-ezcube-planter-21-x-24'
      //       },
      //     ]

      //   },
      //   'the-ezcube-planter-21-x-24-elevated_1': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '12.7031%',
      //         handle: 'metal-frame-string-trellis'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '77.7031%',
      //       },
      //     ]
      //   },
      //   'the-ezcube-planter-21-x-24-elevated_3_1': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '74.7031%',
      //         handle: 'the-ezcube-planter-21-x-24-elevated'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '64.7031%',
      //         handle: 'rolling-planter-twin-pack'
      //       },
      //     ]
      //   },
      //   'the-ezcube-planter-21-x-24-elevated_3': {
      //     desktop: [
      //       {
      //         x: '40.2051%',
      //         y: '64.7031%',
      //         handle: 'the-ezcube-planter-21-x-24-elevated'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '40.2051%',
      //         y: '64.7031%',
      //         handle: 'rolling-planter-twin-pack'
      //       },
      //     ]
      //   },
      //   'the-ezcube-planter-21-x-24-elevated': [
      //     {
      //       x: '60.2051%',
      //       y: '34.7031%',
      //       handle: 'the-ezcube-planter-21-x-24-elevated'
      //     },
      //   ],
      //   'elevated-garden-bed-2-by-4_5': [
      //     {
      //       x: '43.2051%',
      //       y: '80.7031%',
      //       handle: 'elevated-garden-bed-2-by-4'
      //     },
      //   ],
      //   'self-watering-rolling-tomato-planter-pot-with-trellis_1': [
      //     {
      //       x: '63.2051%',
      //       y: '48.7031%',
      //       handle: 'ez-self-watering-herb-planter-with-trellis-g2'
      //     },
      //   ],
      //   'the-ezcube-planter-21-x-24_2': [
      //     {
      //       x: '42.2051%',
      //       y: '77.7031%',
      //       handle: 'the-ezcube-planter-21-x-24'
      //     },
      //   ],
      //   'rolling-planter-twin-pack_2': [
      //     {
      //       x: '42.2051%',
      //       y: '77.7031%',
      //       handle: 'rolling-planter-twin-pack'
      //     },
      //   ],
      //   'the-ezcube-planter-21-x-48_2': {
      //     desktop: [
      //       {
      //         x: '42.2051%',
      //         y: '77.7031%',
      //         handle: 'the-ezcube-planter-21-x-48'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '20.2051%',
      //         y: '77.7031%',
      //         handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //       }
      //     ]
      //   },
      //   // 'self-watering-rolling-tomato-planter-pot-with-trellis': {
      //   //   desktop: [
      //   //     {
      //   //       x: '60.2051%',
      //   //       y: '34.7031%',
      //   //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //   //     },
      //   //   ],
      //   //   mobile: [
      //   //     {
      //   //       x: '60.2051%',
      //   //       y: '64.7031%',
      //   //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //   //     },
      //   //   ]
      //   // },
      //   'ez-self-watering-herb-planter-with-trellis-g2': [
      //     {
      //       x: '60.2051%',
      //       y: '34.7031%',
      //       handle: 'ez-self-watering-herb-planter-with-trellis-g2'
      //     },
      //   ],
      //   '9-in-1-modular-raised-garden-bed': [
      //     {
      //       x: '60.2051%',
      //       y: '34.7031%',
      //       handle: '9-in-1-modular-raised-garden-bed'
      //     },
      //   ],
      //   '32-extra-tall-10-in-1-modular-raised-garden-bed-kit': [
      //     {
      //       x: '60.2051%',
      //       y: '54.7031%',
      //       handle: '32-extra-tall-10-in-1-modular-raised-garden-bed-kit'
      //     },
      //   ],
      //   'kitchen-composter': [
      //     {
      //       x: '30.2051%',
      //       y: '44.7031%',
      //       handle: 'kitchen-composter'
      //     }
      //   ],
      //   'vego-flow-meter-timer': {
      //     desktop: [
      //       {
      //         x: '50.2051%',
      //         y: '64.7031%',
      //         handle: 'vego-digital-water-timer-2-zone'
      //       },
      //     ],

      //     mobile: [
      //       {
      //         x: '50.2051%',
      //         y: '41.7031%',
      //         handle: 'vego-digital-water-timer-2-zone'
      //       },
      //     ]
      //   },
      //   'rolling-self-watering-garden-bed': [
      //     {
      //       x: '42.2051%',
      //       y: '62.7031%',
      //       handle: 'rolling-self-watering-garden-bed'
      //     },
      //   ],
      //   'vego-greenhouses': [
      //     {
      //       x: '62.2051%',
      //       y: '19.7031%',
      //       handle: 'vego-garden-pacific-greenhouse'
      //     },
      //   ],
      //   'vego-garden-pacific-greenhouse': {
      //     desktop: [
      //       {
      //         x: '20.2051%',
      //         y: '42.7031%',
      //         handle: 'vego-garden-pacific-greenhouse'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '24.2051%',
      //         y: '32.7031%',
      //         handle: 'vego-garden-pacific-greenhouse'
      //       },
      //     ]
      //   },
      //   'retractable-hose-reel-set-130': [
      //     {
      //       x: '40.2051%',
      //       y: '44.7031%',
      //       handle: 'retractable-hose-reel-set-130'
      //     },
      //   ],
      //   // Father's Day Collection END 
      //   'the-ezcube-planter-21-x-48-1': {
      //     desktop: [
      //       {
      //         x: '73.0662%',
      //         y: '61.8644%',
      //         handle: 'the-ezcube-planter-21-x-48'
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: '64.4172%',
      //         y: '51.9149%',
      //         handle: 'the-ezcube-planter-21-x-48'
      //       },
      //     ]
      //   }
      // }
      // let vego_day_config = {
      //   "foodcube-slim": [
      //     {
      //       x: "20.2051%",
      //       y: "68.7031%",
      //       handle: "foodcube-slim",
      //     },
      //   ],
      //   "9-in-1-modular-raised-garden-bed_2": {
      //     desktop: [
      //       {
      //         x: "48.2051%",
      //         y: "66.7031%",
      //         handle: "10-in-1-modular-metal-raised-garden-bed-kit",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "46.2051%",
      //         y: "65.7031%",
      //         handle: "10-in-1-modular-metal-raised-garden-bed-kit",
      //       },
      //     ],
      //   },
      //   "rolling-planter-twin-pack": {
      //     desktop: [
      //       {
      //         x: "45.2051%",
      //         y: "70.7031%",
      //         handle: "rolling-planter-twin-pack",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "41.2051%",
      //         y: "70.7031%",
      //         handle: "rolling-planter-twin-pack",
      //       },
      //     ],
      //   },
      //   ezcube_planter_2: {
      //     desktop: [
      //       {
      //         x: "45.2051%",
      //         y: "70.7031%",
      //         handle:
      //           "the-ezcube-self-watering-planter-21-x-24-elevated-sage-green",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "41.2051%",
      //         y: "70.7031%",
      //         handle:
      //           "the-ezcube-self-watering-planter-21-x-24-elevated-sage-green",
      //       },
      //     ],
      //   },
      //   ez_planter_2: {
      //     desktop: [
      //       {
      //         x: "67.2051%",
      //         y: "70.7031%",
      //         handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
      //       },
      //       {
      //         x: "13.2051%",
      //         y: "53.7031%",
      //         handle: "ez-self-watering-herb-planter-with-trellis-g2",
      //       },
      //       {
      //         x: "40.2051%",
      //         y: "53.7031%",
      //         handle: "self-watering-mini-planter-pot-with-trellis",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "67.2051%",
      //         y: "70.7031%",
      //         handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
      //       },
      //       {
      //         x: "13.2051%",
      //         y: "48.7031%",
      //         handle: "ez-self-watering-herb-planter-with-trellis-g2",
      //       },
      //       {
      //         x: "40.2051%",
      //         y: "48.7031%",
      //         handle: "self-watering-mini-planter-pot-with-trellis",
      //       },
      //     ],
      //   },

      //   "9-in-1-modular-raised-garden-bed_1": {
      //     desktop: [
      //       {
      //         x: "50.2051%",
      //         y: "60.7031%",
      //         handle: "9-in-1-modular-raised-garden-bed",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "50.2051%",
      //         y: "55.7031%",
      //         handle: "9-in-1-modular-raised-garden-bed",
      //       },
      //     ],
      //   },
      //   "elevated-garden-bed-v-series-2-x-4-with-wheels": {
      //     desktop: [
      //       {
      //         x: "50.2051%",
      //         y: "50.7031%",
      //         handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "50.2051%",
      //         y: "50.7031%",
      //         handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
      //       },
      //     ],
      //   },
      //   "the-ezcube-planter-21-x-48": [
      //     {
      //       x: "60.2051%",
      //       y: "67.7031%",
      //       handle: "the-ezcube-planter-21-x-48",
      //     },
      //   ],
      //   "the-grow-light-garden-series-f4_21": {
      //     desktop: [
      //       {
      //         x: "52.2051%",
      //         y: "30.7031%",
      //         handle: "vego-irrigation-kit",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "34.2051%",
      //         y: "26.7031%",
      //         handle: "vego-irrigation-kit",
      //       },
      //     ],
      //   },
      //   "vego-irrigation-kit_2": {
      //     desktop: [
      //       {
      //         x: "52.2051%",
      //         y: "30.7031%",
      //         handle: "garden-bed-mister",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "59.2051%",
      //         y: "36.7031%",
      //         handle: "self-watering-wicking-floor",
      //       },
      //     ],
      //   },
      //   "metal-frame-string-trellis_2": {
      //     desktop: [
      //       {
      //         x: "7.2051%",
      //         y: "54.7031%",
      //         handle: "metal-frame-string-trellis",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "6.2051%",
      //         y: "44.7031%",
      //         handle: "metal-frame-string-trellis",
      //       },
      //     ],
      //   },
      //   "garden-arch-trellis_2": {
      //     desktop: [
      //       {
      //         x: "50.2051%",
      //         y: "39.7031%",
      //         handle: "garden-arch-trellis",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "20.2051%",
      //         y: "33.7031%",
      //         handle: "garden-arch-trellis",
      //       },
      //     ],
      //   },
      //   "modular-wall-trellis-system_2": {
      //     desktop: [
      //       {
      //         x: "51.2051%",
      //         y: "34.7031%",
      //         handle: "modular-wall-trellis-system",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "47.2051%",
      //         y: "34.7031%",
      //         handle: "modular-wall-trellis-system",
      //       },
      //     ],
      //   },

      //   "vego-hose-reel-cover": {
      //     desktop: [
      //       {
      //         x: "40.2051%",
      //         y: "54.7031%",
      //         handle: "vego-hose-reel-cover",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "40.2051%",
      //         y: "54.7031%",
      //         handle: "vego-hose-reel-cover",
      //       },
      //     ],
      //   },
      //   "10-in-1-modular-metal-raised-garden-bed-kit_2": {
      //     desktop: [
      //       {
      //         x: "20.2051%",
      //         y: "38.2031%",
      //         handle: "vego-garden-cover-system-g2",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "22.2051%",
      //         y: "40.7031%",
      //         handle: "vego-garden-cover-system-g2",
      //       },
      //     ],
      //   },
      //   "10-in-1-modular-metal-raised-garden-bed-kit": {
      //     desktop: [
      //       {
      //         x: "40.2051%",
      //         y: "58.2031%",
      //         handle: "vego-irrigation-kit",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "40.2051%",
      //         y: "1.7031%",
      //         handle: "metal-frame-string-trellis",
      //       },
      //     ],
      //   },
      //   "hi-flow-retractable-hose-reel-set-100": [
      //     {
      //       x: "60.2051%",
      //       y: "34.7031%",
      //       handle: "hi-flow-retractable-hose-reel-set-100",
      //     },
      //   ],
      //   "hi-flow-retractable-hose-reel-set-100_1": [
      //     {
      //       x: "60.2051%",
      //       y: "52.7031%",
      //       handle: "ez-self-watering-herb-planter-with-trellis-g2",
      //     },
      //   ],
      //   "elevated-garden-bed-2-by-4": [
      //     {
      //       x: "60.2051%",
      //       y: "34.7031%",
      //       handle: "elevated-garden-bed-2-by-4",
      //     },
      //   ],

      //   "the-grow-light-garden-series-f4_2": {
      //     desktop: [
      //       {
      //         x: "34.2051%",
      //         y: "34.7031%",
      //         handle: "vego-irrigation-kit",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "41.2051%",
      //         y: "47.7031%",
      //         handle: "retractable-hose-reel-set-130",
      //       },
      //     ],
      //   },
      //   "the-ezcube-planter-21-x-24-elevated_1": {
      //     desktop: [
      //       {
      //         x: "40.2051%",
      //         y: "12.7031%",
      //         handle: "metal-frame-string-trellis",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "40.2051%",
      //         y: "77.7031%",
      //       },
      //     ],
      //   },
      //   "the-ezcube-planter-21-x-24-elevated_3_1": {
      //     desktop: [
      //       {
      //         x: "40.2051%",
      //         y: "74.7031%",
      //         handle: "the-ezcube-planter-21-x-24-elevated",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "40.2051%",
      //         y: "64.7031%",
      //         handle: "rolling-planter-twin-pack",
      //       },
      //     ],
      //   },
      //   "the-ezcube-planter-21-x-24-elevated_3": {
      //     desktop: [
      //       {
      //         x: "40.2051%",
      //         y: "64.7031%",
      //         handle: "the-ezcube-planter-21-x-24-elevated",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "40.2051%",
      //         y: "64.7031%",
      //         handle: "wicking-cells",
      //       },
      //     ],
      //   },
      //   "the-ezcube-planter-21-x-24-elevated": [
      //     {
      //       x: "60.2051%",
      //       y: "34.7031%",
      //       handle: "the-ezcube-planter-21-x-24-elevated",
      //     },
      //   ],
      //   "elevated-garden-bed-2-by-4_5": [
      //     {
      //       x: "43.2051%",
      //       y: "80.7031%",
      //       handle: "elevated-garden-bed-2-by-4",
      //     },
      //   ],
      //   "self-watering-rolling-tomato-planter-pot-with-trellis_1": [
      //     {
      //       x: "63.2051%",
      //       y: "48.7031%",
      //       handle: "ez-self-watering-herb-planter-with-trellis-g2",
      //     },
      //   ],
      //   "the-ezcube-planter-21-x-24_2": [
      //     {
      //       x: "42.2051%",
      //       y: "47.7031%",
      //       handle: "wicking-cells",
      //     },
      //   ],
      //   "rolling-planter-twin-pack_2": [
      //     {
      //       x: "42.2051%",
      //       y: "77.7031%",
      //       handle: "rolling-planter-twin-pack",
      //     },
      //   ],
      //   "the-ezcube-planter-21-x-48_2": {
      //     desktop: [
      //       {
      //         x: "57.2051%",
      //         y: "65.7031%",
      //         handle: "self-watering-wicking-floor",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "56.2051%",
      //         y: "32.7031%",
      //         handle: "garden-bed-mister",
      //       },
      //     ],
      //   },
      //   // 'self-watering-rolling-tomato-planter-pot-with-trellis': {
      //   //   desktop: [
      //   //     {
      //   //       x: '60.2051%',
      //   //       y: '34.7031%',
      //   //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //   //     },
      //   //   ],
      //   //   mobile: [
      //   //     {
      //   //       x: '60.2051%',
      //   //       y: '64.7031%',
      //   //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
      //   //     },
      //   //   ]
      //   // },
      //   "ez-self-watering-herb-planter-with-trellis-g2": [
      //     {
      //       x: "60.2051%",
      //       y: "34.7031%",
      //       handle: "ez-self-watering-herb-planter-with-trellis-g2",
      //     },
      //   ],
      //   "9-in-1-modular-raised-garden-bed": [
      //     {
      //       x: "60.2051%",
      //       y: "34.7031%",
      //       handle: "9-in-1-modular-raised-garden-bed",
      //     },
      //   ],
      //   "32-extra-tall-10-in-1-modular-raised-garden-bed-kit": [
      //     {
      //       x: "60.2051%",
      //       y: "54.7031%",
      //       handle: "32-extra-tall-10-in-1-modular-raised-garden-bed-kit",
      //     },
      //   ],
      //   "kitchen-composter": [
      //     {
      //       x: "30.2051%",
      //       y: "44.7031%",
      //       handle: "kitchen-composter",
      //     },
      //   ],
      //   "vego-flow-meter-timer": {
      //     desktop: [
      //       {
      //         x: "50.2051%",
      //         y: "64.7031%",
      //         handle: "vego-digital-water-timer-2-zone",
      //       },
      //     ],

      //     mobile: [
      //       {
      //         x: "50.2051%",
      //         y: "41.7031%",
      //         handle: "vego-digital-water-timer-2-zone",
      //       },
      //     ],
      //   },
      //   "rolling-self-watering-garden-bed": [
      //     {
      //       x: "42.2051%",
      //       y: "62.7031%",
      //       handle: "rolling-self-watering-garden-bed",
      //     },
      //   ],
      //   "vego-greenhouses": [
      //     {
      //       x: "62.2051%",
      //       y: "19.7031%",
      //       handle: "vego-garden-pacific-greenhouse",
      //     },
      //   ],
      //   "vego-garden-pacific-greenhouse": {
      //     desktop: [
      //       {
      //         x: "20.2051%",
      //         y: "42.7031%",
      //         handle: "vego-garden-pacific-greenhouse",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "24.2051%",
      //         y: "32.7031%",
      //         handle: "vego-garden-pacific-greenhouse",
      //       },
      //     ],
      //   },
      //   "retractable-hose-reel-set-130": [
      //     {
      //       x: "40.2051%",
      //       y: "44.7031%",
      //       handle: "retractable-hose-reel-set-130",
      //     },
      //   ],
      //   // Father's Day Collection END
      //   "the-ezcube-planter-21-x-48-1": {
      //     desktop: [
      //       {
      //         x: "73.0662%",
      //         y: "61.8644%",
      //         handle: "the-ezcube-planter-21-x-48",
      //       },
      //     ],
      //     mobile: [
      //       {
      //         x: "64.4172%",
      //         y: "51.9149%",
      //         handle: "the-ezcube-planter-21-x-48",
      //       },
      //     ],
      //   },
      // };
      let home_v2025_config = {
        "home_v2025_discover-what-gardeners-are-loving_item_1": {
          desktop: [
            {
              x: "30%",
              label: "bed",
              y: "71.935484%",
              handle: "9-in-1-modular-raised-garden-bed",
            },
            {
              x: "15.789474%",
              label: "seeds",
              y: "23.870968%",
              handle: "modular-wall-trellis-system",
            },
          ],
          mobile: [
            {
              x: "30.083333%",
              label: "bed",
              y: "4.967742%",
              handle: "potting-bench-hooks-4-pack",
            },
            {
              x: "61.240741%",
              label: "seeds",
              y: "6.032258%",
              handle: "hanging-rack-shelf-set",
            },
            {
              x: "56.240741%",
              label: "seeds",
              y: "22.032258%",
              handle: "potting-bench-hanging-rack",
            },
            {
              x: "82.240741%",
              label: "seeds",
              y: "29.032258%",
              handle: "potting-bench-bar-top-shelf",
            },
            {
              x: "62.240741%",
              label: "seeds",
              y: "75.032258%",
              handle: "potting-bench-add-on-cabinet",
            },
            // {
            //   x: "46.865672%",
            //   label: "bed",
            //   y: "69.198312%",
            //   handle: "9-in-1-modular-raised-garden-bed",
            // },
            // {
            //   x: "28.955224%",
            //   label: "seeds",
            //   y: "19.409283%",
            //   handle: "modular-wall-trellis-system",
            // },
          ],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_2": {
          desktop: [
            {
              x: "39.736842%",
              label: "elevated",
              y: "56.315789%",
              handle: "elevated-garden-bed-2-x-8",
            },
            {
              x: "63.157895%",
              label: "cover",
              y: "25.263158%",
              handle: "4-in-1-trellis-cover-system",
            },
          ],
          mobile: [
            {
              x: "63.157895%",
              label: "greenhouse",
              y: "25.263158%",
              handle: "4-in-1-trellis-cover-system",
            },
          ],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_3": {
          desktop: [
            {
              x: "73.611111%",
              label: "greenhouse",
              y: "39.210526%",
              handle: "vego-garden-victorian-greenhouse-12-5-ft",
            },
            {
              x: "33.796296%",
              label: "greenhouse",
              y: "28.947368%",
              handle: "auto-vent-opener-2-pack",
            },
            // {
            //   x: "75.796296%",
            //   label: "greenhouse",
            //   y: "74.947368%",
            //   handle: "rolling-planter-twin-pack",
            // },
            // {
            //   x: "12.796296%",
            //   label: "greenhouse",
            //   y: "64.947368%",
            //   handle: "bistro-set",
            // },
          ],
          mobile: [
            {
              x: "46.865672%",
              label: "bed",
              y: "69.198312%",
              handle: "9-in-1-modular-raised-garden-bed",
            },
            {
              x: "20.955224%",
              label: "seeds",
              y: "19.409283%",
              handle: "modular-wall-trellis-system",
            },
            // {
            //   x: "18.404908%",
            //   label: "bed",
            //   y: "79.141104%",
            //   handle: "9-in-1-modular-raised-garden-bed",
            // },
            // {
            //   x: "49.693252%",
            //   label: "seeds",
            //   y: "82.208589%",
            //   handle: "vego-irrigation-kit",
            // },
          ],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_4": {
          desktop: [
            {
              x: "45.083333%",
              label: "bed",
              y: "12.967742%",
              handle: "potting-bench-hooks-4-pack",
            },
            {
              x: "53.240741%",
              label: "seeds",
              y: "14.032258%",
              handle: "hanging-rack-shelf-set",
            },
            {
              x: "56.240741%",
              label: "seeds",
              y: "20.032258%",
              handle: "potting-bench-hanging-rack",
            },
            {
              x: "85.240741%",
              label: "seeds",
              y: "33.032258%",
              handle: "potting-bench-bar-top-shelf",
            },
            {
              x: "74.240741%",
              label: "seeds",
              y: "75.032258%",
              handle: "potting-bench-add-on-cabinet",
            },
          ],
          mobile: [
            {
              x: "49.693252%",
              label: "elevated",
              y: "56.682028%",
              handle: "32-extra-tall-9-in-1-modular-raised-garden-bed-kit",
            },
            {
              x: "52.760736%",
              label: "cover",
              y: "20.276498%",
              handle: "vego-greenhouse-cover-system",
            },
          ],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_5": {
          desktop: [
            {
              x: "39.736842%",
              label: "elevated",
              y: "56.315789%",
              handle: "32-extra-tall-9-in-1-modular-raised-garden-bed-kit",
            },
            {
              x: "63.157895%",
              label: "cover",
              y: "25.263158%",
              handle: "vego-greenhouse-cover-system",
            },
          ],
          mobile: [
            {
              x: "31.288344%",
              label: "greenhouse",
              y: "63.133641%",
              handle: "vego-garden-victorian-greenhouse-12-5-ft",
            },
            // {
            //   x: "31.288344%",
            //   label: "greenhouse",
            //   y: "37.327189%",
            //   handle: "auto-vent-opener-2-pack",
            // },
          ],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_6_mobile": {
          mobile: [
            {
              x: "15.2051%",
              label: "indoor",
              y: "54.7031%",
              handle: "grow-light-garden-conversion-kit",
            },
            {
              x: "16.2051%",
              label: "planter",
              y: "73.7031%",
              handle: "ez-self-watering-herb-planter-with-trellis-g2",
            },
            {
              x: "49.2051%",
              label: "seed tray",
              y: "19.7031%",
              handle: "seed-starting-bundle-10-in-x-20-in",
            },
            {
              x: "73.2051%",
              label: "indoor pro",
              y: "72.7031%",
              handle: "the-grow-light-garden-series-f4s-pro",
            },
          ],
          desktop: [],
        },
        "home_v2025_discover-what-gardeners-are-loving_item_6": {
          desktop: [
            // {
            //   x: "62.2051%",
            //   label: "indoor",
            //   y: "5.7031%",
            //   handle: "vego-garden-victorian-greenhouse-12-5-ft",
            // },
            {
              x: "16.2051%",
              label: "planter",
              y: "77.7031%",
              handle: "ez-self-watering-herb-planter-with-trellis-g2",
            },
            {
              x: "50.2051%",
              label: "seed tray",
              y: "33.7031%",
              handle: "seed-starting-bundle-10-in-x-20-in",
            },
            {
              x: "75.2051%",
              label: "indoor pro",
              y: "76.7031%",
              handle: "the-grow-light-garden-series-f4s-pro",
            },
          ],
          mobile: [
            {
              x: "40.2051%",
              label: "elevated",
              y: "50.7031%",
              handle: "elevated-garden-bed-v-series-2-x-6-with-wheels",
            },
            {
              x: "70.2051%",
              label: "cover",
              y: "40.7031%",
              handle: "4-in-1-trellis-cover-system",
            },
          ],
        },
      };
      let father_day_v2026_config = {
        mother_s_day_discover_v2026_1_1: {
          desktop: [
            {
              x: "25%",
              label: "bed",
              y: "62.9355%",
              handle: "9-pattern-turret-sprinkler",
            },
          ],
          mobile: [
            {
              x: "16%",
              label: "bed",
              y: "16.9355%",
              handle: "vego-irrigation-kit",
            },
          ],
        },
        mother_s_day_discover_v2026_1_2: {
          desktop: [
            {
              x: "45%",
              label: "bed",
              y: "25.9355%",
              handle: "9-pattern-spray-nozzle-thumb",
            },
          ],
          mobile: [
            {
              x: "27%",
              label: "bed",
              y: "75.9355%",
              handle: "9-pattern-spray-nozzle-thumb",
            },
          ],
        },
        mother_s_day_discover_v2026_3_1: {
          desktop: [
            {
              x: "61%",
              label: "bed",
              y: "31.9355%",
              handle: "retractable-hose-reel-set-130",
            },
          ],
          mobile: [
            {
              x: "22%",
              label: "bed",
              y: "47.9355%",
              handle: "9-pattern-turret-sprinkler",
            },
          ],
        },
        mother_s_day_discover_v2026_4_1: {
          desktop: [
            {
              x: "47%",
              label: "bed",
              y: "48.9355%",
              handle: "vego-digital-water-timer-1-zone",
            },
          ],
          mobile: [
            {
              x: "36%",
              label: "bed",
              y: "22.9355%",
              handle: "9-pattern-spray-nozzle-thumb",
            },
          ],
        },
        mother_s_day_discover_v2026_5_1: {
          desktop: [
            {
              x: "42%",
              label: "bed",
              y: "27.9355%",
              handle: "vego-irrigation-kit",
            },
          ],
          mobile: [
            {
              x: "56%",
              label: "bed",
              y: "26.9355%",
              handle: "retractable-hose-reel-set-130",
            },
          ],
        },
        mother_s_day_discover_v2026_5_2: {
          desktop: [
            {
              x: "27%",
              label: "bed",
              y: "75.9355%",
              handle: "vego-irrigation-kit",
            },
          ],
          mobile: [
            {
              x: "41%",
              label: "bed",
              y: "42.9355%",
              handle: "vego-digital-water-timer-1-zone",
            },
          ],
        },
        mother_s_day_discover_v2026_1: {
          desktop: [
            {
              x: "27%",
              label: "bed",
              y: "75.9355%",
              handle: "elevated-garden-bed-jumbo-series-3-x-8",
            },
          ],
          mobile: [
            {
              x: "27%",
              label: "bed",
              y: "75.9355%",
              handle: "elevated-garden-bed-jumbo-series-3-x-8",
            },
          ],
        },

        mother_s_day_discover_v2026_3: {
          desktop: [
            {
              x: "51%",
              label: "bed",
              y: "52.935484%",
              handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
            },
          ],
          mobile: [
            {
              x: "39.083333%",
              label: "bed",
              y: "45.935484%",
              handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
            },
          ],
        },
        mother_s_day_discover_v2026_4: {
          desktop: [
            {
              x: "43%",
              label: "bed",
              y: "46.935484%",
              handle: "woodgrain-elevated-garden-bed-2-0-x-6-0",
            },
          ],
          mobile: [
            {
              x: "39.083333%",
              label: "bed",
              y: "40.967742%",
              handle: "woodgrain-elevated-garden-bed-2-0-x-6-0",
            },
          ],
        },
        mother_s_day_discover_v2026_5: {
          desktop: [
            {
              x: "56.3%",
              label: "bed",
              y: "22.935484%",
              handle: "4-in-1-trellis-cover-system",
            },
          ],
          mobile: [
            {
              x: "27.083333%",
              label: "bed",
              y: "20.967742%",
              handle: "4-in-1-trellis-cover-system",
            },
          ],
        },
        mother_s_day_discover_v2026_6: {
          desktop: [],
          mobile: [
            {
              x: "52.083333%",
              label: "bed",
              y: "48.967742%",
              handle: "border-plant-support-wavy-6-pack",
            },
          ],
        },
      };
      let mother_day_v2026_config = {
        mother_s_day_discover_v2026_1: {
          desktop: [
            {
              x: "35%",
              label: "bed",
              y: "39.9355%",
              handle: "mounted-wall-trellis",
            },
          ],
          mobile: [
            {
              x: "52.5%",
              label: "bed",
              y: "62.9355%",
              handle: "garden-arch-trellis",
            },
          ],
        },
        mother_s_day_discover_v2026_2: {
          desktop: [
            {
              x: "59%",
              label: "bed",
              y: "68.935484%",
              handle: "17-tall-modern-raised-garden-bed-4283",
            },
          ],
          mobile: [
            {
              x: "30.083333%",
              label: "bed",
              y: "4.967742%",
              handle: "potting-bench-hooks-4-pack",
            },
          ],
        },
        mother_s_day_discover_v2026_3: {
          desktop: [
            {
              x: "51%",
              label: "bed",
              y: "58.935484%",
              handle: "elevated-garden-bed-2-x-6",
            },
          ],
          mobile: [
            {
              x: "30.083333%",
              label: "bed",
              y: "29.967742%",
              handle: "mounted-wall-trellis",
            },
          ],
        },
        mother_s_day_discover_v2026_4: {
          desktop: [
            {
              x: "67%",
              label: "bed",
              y: "54.935484%",
              handle: "border-plant-support-wavy-6-pack",
            },
          ],
          mobile: [
            {
              x: "51.083333%",
              label: "bed",
              y: "67.967742%",
              handle: "17-tall-modern-raised-garden-bed-4283",
            },
          ],
        },
        mother_s_day_discover_v2026_5: {
          desktop: [
            {
              x: "59.3%",
              label: "bed",
              y: "71.935484%",
              handle: "garden-arch-trellis",
            },
          ],
          mobile: [
            {
              x: "42.083333%",
              label: "bed",
              y: "57.967742%",
              handle: "elevated-garden-bed-2-x-6",
            },
          ],
        },
        mother_s_day_discover_v2026_6: {
          desktop: [],
          mobile: [
            {
              x: "52.083333%",
              label: "bed",
              y: "48.967742%",
              handle: "border-plant-support-wavy-6-pack",
            },
          ],
        },
      };
      let hightConfig = {
        // Mother's Day Collection
        // 'dragon-fruit-planter-bundle':{
        //   desktop:[

        //     {
        //       x: '50.2051%',
        //       y: '78.7031%',
        //       handle: 'dragon-fruit-planter-bundle'
        //     },
        //   ],
        //   mobile:[

        //     {
        //       x: '50.2051%',
        //       y: '78.7031%',
        //       handle: 'dragon-fruit-planter-bundle'
        //     },
        //   ],
        // },
        // 'grow-light-stand-herb-planter-bundle':[
        //   {
        //     x: '60.2051%',
        //     y: '17.7031%',
        //     handle: 'the-vego-grow-light-stand'
        //   },
        //   {
        //     x: '50.2051%',
        //     y: '72.7031%',
        //     handle: 'ez-self-watering-herb-planter-with-trellis-g2'
        //   },
        // ],
        // 'hi-flow-retractable-hose-reel-set-100':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: 'hi-flow-retractable-hose-reel-set-100'
        //   },
        // ],
        // 'hi-flow-retractable-hose-reel-set-100_1':[
        //   {
        //     x: '60.2051%',
        //     y: '52.7031%',
        //     handle: 'ez-self-watering-herb-planter-with-trellis-g2'
        //   }
        // ],
        // 'elevated-garden-bed-2-by-4':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: 'elevated-garden-bed-2-by-4'
        //   },
        // ],
        // 'the-ezcube-planter-21-x-24-elevated_1':{
        //   desktop:[
        //     {
        //       x: '40.2051%',
        //       y: '64.7031%',
        //       handle: 'the-ezcube-planter-21-x-24-elevated'
        //     },
        //   ],
        //   mobile:[
        //     {
        //       x: '40.2051%',
        //       y: '77.7031%',
        //       handle: 'elevated-garden-bed-2-by-4'
        //     },
        //   ]
        // },
        // 'the-ezcube-planter-21-x-24-elevated_3':{
        //   desktop:[
        //     {
        //       x: '40.2051%',
        //       y: '64.7031%',
        //       handle: 'the-ezcube-planter-21-x-24-elevated'
        //     },
        //   ],
        //   mobile:[
        //     {
        //       x: '40.2051%',
        //       y: '64.7031%',
        //       handle: 'the-ezcube-planter-21-x-24-elevated'
        //     },
        //   ]
        // },
        // 'the-ezcube-planter-21-x-24-elevated':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: 'the-ezcube-planter-21-x-24-elevated'
        //   },
        // ],
        // 'elevated-garden-bed-2-by-4_5':[
        //   {
        //     x: '43.2051%',
        //     y: '80.7031%',
        //     handle: 'elevated-garden-bed-2-by-4'
        //   },
        // ],
        // 'self-watering-rolling-tomato-planter-pot-with-trellis_1':[
        //   {
        //     x: '63.2051%',
        //     y: '48.7031%',
        //     handle: 'ez-self-watering-herb-planter-with-trellis-g2'
        //   },
        // ],
        // 'self-watering-rolling-tomato-planter-pot-with-trellis_2':{
        //   desktop:[
        //     {
        //       x: '42.2051%',
        //       y: '77.7031%',
        //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
        //     },
        //   ],
        //   mobile:[
        //     {
        //       x: '37.2051%',
        //       y: '70.7031%',
        //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
        //     },
        //   ]
        // },
        // 'self-watering-rolling-tomato-planter-pot-with-trellis':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
        //   },
        // ],
        // 'ez-self-watering-herb-planter-with-trellis-g2':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: 'ez-self-watering-herb-planter-with-trellis-g2'
        //   },
        // ],
        // '9-in-1-modular-raised-garden-bed':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: '9-in-1-modular-raised-garden-bed'
        //   },
        // ],
        // '32-extra-tall-10-in-1-modular-raised-garden-bed-kit':[
        //   {
        //     x: '60.2051%',
        //     y: '54.7031%',
        //     handle: '32-extra-tall-10-in-1-modular-raised-garden-bed-kit'
        //   },
        // ],
        // 'elevated-garden-bed-2-by-4_1':{
        //   desktop:[
        //     {
        //       x: '50.2051%',
        //       y: '64.7031%',
        //       handle: 'elevated-garden-bed-2-by-4'
        //     },
        //   ],

        //   mobile:[
        //     {
        //       x: '50.2051%',
        //       y: '41.7031%',
        //       handle: 'elevated-garden-bed-2-by-4'
        //     },
        //   ]
        // },
        // 'rolling-self-watering-garden-bed':[
        //   {
        //     x: '42.2051%',
        //     y: '62.7031%',
        //     handle: 'rolling-self-watering-garden-bed'
        //   },
        // ],
        // 'vego-greenhouses':[
        //   {
        //     x: '62.2051%',
        //     y: '19.7031%',
        //     handle: 'vego-garden-pacific-greenhouse'
        //   },
        // ],
        // '17-tall-4-in-1-modular-metal-raised-garden-bed-kit':{
        //   desktop:[
        //     {
        //       x: '40.2051%',
        //       y: '72.7031%',
        //       handle: '17-tall-4-in-1-modular-metal-raised-garden-bed-kit'
        //     },
        //   ],
        //   mobile:[
        //     {
        //       x: '66.2051%',
        //       y: '72.7031%',
        //       handle: '17-tall-4-in-1-modular-metal-raised-garden-bed-kit'
        //     },
        //   ]
        // },
        // '32-extra-tall-10-in-1-modular-raised-garden-bed-kit_1':[
        //   {
        //     x: '60.2051%',
        //     y: '34.7031%',
        //     handle: '32-extra-tall-10-in-1-modular-raised-garden-bed-kit'
        //   },
        // ],
        // Mother's Day Collection END

        // Father's Day Collection Begin
        "foodcube-slim": [
          {
            x: "20.2051%",
            y: "68.7031%",
            handle: "foodcube-slim",
          },
        ],
        "elevated-garden-bed-v-series-2-x-4-with-wheels": {
          desktop: [
            {
              x: "50.2051%",
              y: "50.7031%",
              handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
            },
          ],
          mobile: [
            {
              x: "50.2051%",
              y: "50.7031%",
              handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
            },
          ],
        },
        "the-ezcube-planter-21-x-48": [
          {
            x: "60.2051%",
            y: "67.7031%",
            handle: "the-ezcube-planter-21-x-48",
          },
        ],
        "self-watering-rolling-tomato-planter-pot-with-trellis": {
          desktop: [
            {
              x: "20.2051%",
              y: "84.7031%",
              handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
            },
          ],
          mobile: [
            {
              x: "20.2051%",
              y: "74.7031%",
              handle: "the-ezcube-planter-21-x-24",
            },
          ],
        },
        "vego-hose-reel-cover": {
          desktop: [
            {
              x: "40.2051%",
              y: "54.7031%",
              handle: "vego-hose-reel-cover",
            },
          ],
          mobile: [
            {
              x: "40.2051%",
              y: "54.7031%",
              handle: "vego-hose-reel-cover",
            },
          ],
        },
        "10-in-1-modular-metal-raised-garden-bed-kit": {
          desktop: [
            {
              x: "40.2051%",
              y: "58.2031%",
              handle: "vego-irrigation-kit",
            },
          ],
          mobile: [
            {
              x: "40.2051%",
              y: "1.7031%",
              handle: "metal-frame-string-trellis",
            },
          ],
        },
        "hi-flow-retractable-hose-reel-set-100": [
          {
            x: "60.2051%",
            y: "34.7031%",
            handle: "hi-flow-retractable-hose-reel-set-100",
          },
        ],
        "hi-flow-retractable-hose-reel-set-100_1": [
          {
            x: "60.2051%",
            y: "52.7031%",
            handle: "ez-self-watering-herb-planter-with-trellis-g2",
          },
        ],
        "elevated-garden-bed-2-by-4": [
          {
            x: "60.2051%",
            y: "34.7031%",
            handle: "elevated-garden-bed-2-by-4",
          },
        ],
        "the-grow-light-garden-series-f4_21": [
          {
            x: "40.2051%",
            y: "4.7031%",
            handle: "the-grow-light-garden-series-f4",
          },
        ],
        // "the-grow-light-garden-series-f4_2": {
        //   desktop: [
        //     {
        //       x: "40.2051%",
        //       y: "14.7031%",
        //       handle: "the-grow-light-garden-series-f4",
        //     },
        //   ],
        //   mobile: [
        //     {
        //       x: "41.2051%",
        //       y: "47.7031%",
        //       handle: "retractable-hose-reel-set-130",
        //     },
        //   ],
        // },
        "the-ezcube-planter-21-x-24-elevated_1": {
          desktop: [
            {
              x: "40.2051%",
              y: "12.7031%",
              handle: "metal-frame-string-trellis",
            },
          ],
          mobile: [
            // {
            //   x: "40.2051%",
            //   y: "77.7031%",
            //   handle:
            //     "17-tall-10-in-1-novel-modular-metal-raised-garden-bed-kit",
            // },
          ],
        },
        "the-ezcube-planter-21-x-24-elevated_3_1": {
          desktop: [
            {
              x: "40.2051%",
              y: "74.7031%",
              handle: "the-ezcube-planter-21-x-24-elevated",
            },
          ],
          mobile: [
            {
              x: "40.2051%",
              y: "64.7031%",
              handle: "rolling-planter-twin-pack",
            },
          ],
        },
        "the-ezcube-planter-21-x-24-elevated_3": {
          desktop: [
            {
              x: "40.2051%",
              y: "64.7031%",
              handle: "the-ezcube-planter-21-x-24-elevated",
            },
          ],
          mobile: [
            {
              x: "40.2051%",
              y: "64.7031%",
              handle: "wicking-cells",
            },
          ],
        },
        "the-ezcube-planter-21-x-24-elevated": [
          {
            x: "60.2051%",
            y: "34.7031%",
            handle: "the-ezcube-planter-21-x-24-elevated",
          },
        ],
        "elevated-garden-bed-2-by-4_5": [
          {
            x: "43.2051%",
            y: "80.7031%",
            handle: "elevated-garden-bed-2-by-4",
          },
        ],
        "self-watering-rolling-tomato-planter-pot-with-trellis_1": [
          {
            x: "63.2051%",
            y: "48.7031%",
            handle: "ez-self-watering-herb-planter-with-trellis-g2",
          },
        ],
        "the-ezcube-planter-21-x-24_2": [
          {
            x: "42.2051%",
            y: "77.7031%",
            handle: "the-ezcube-planter-21-x-24",
          },
        ],
        "rolling-planter-twin-pack_2_1": [
          {
            x: "41.2051%",
            y: "47.7031%",
            handle: "retractable-hose-reel-set-130",
          },
        ],
        "the-ezcube-planter-21-x-48_2": {
          desktop: [
            {
              x: "42.2051%",
              y: "77.7031%",
              handle: "the-ezcube-planter-21-x-48",
            },
          ],
          mobile: [
            {
              x: "20.2051%",
              y: "77.7031%",
              handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
            },
          ],
        },
        // 'self-watering-rolling-tomato-planter-pot-with-trellis': {
        //   desktop: [
        //     {
        //       x: '60.2051%',
        //       y: '34.7031%',
        //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
        //     },
        //   ],
        //   mobile: [
        //     {
        //       x: '60.2051%',
        //       y: '64.7031%',
        //       handle: 'self-watering-rolling-tomato-planter-pot-with-trellis'
        //     },
        //   ]
        // },
        "ez-self-watering-herb-planter-with-trellis-g2": [
          {
            x: "60.2051%",
            y: "34.7031%",
            handle: "ez-self-watering-herb-planter-with-trellis-g2",
          },
        ],
        "9-in-1-modular-raised-garden-bed": [
          {
            x: "60.2051%",
            y: "34.7031%",
            handle: "9-in-1-modular-raised-garden-bed",
          },
        ],
        "32-extra-tall-10-in-1-modular-raised-garden-bed-kit": [
          {
            x: "60.2051%",
            y: "54.7031%",
            handle: "32-extra-tall-10-in-1-modular-raised-garden-bed-kit",
          },
        ],
        "kitchen-composter": [
          {
            x: "30.2051%",
            y: "44.7031%",
            handle: "kitchen-composter",
          },
        ],
        "vego-flow-meter-timer": {
          desktop: [
            {
              x: "50.2051%",
              y: "64.7031%",
              handle: "vego-digital-water-timer-2-zone",
            },
          ],

          mobile: [
            {
              x: "50.2051%",
              y: "41.7031%",
              handle: "vego-digital-water-timer-2-zone",
            },
          ],
        },
        "rolling-self-watering-garden-bed": [
          {
            x: "42.2051%",
            y: "62.7031%",
            handle: "rolling-self-watering-garden-bed",
          },
        ],
        "vego-greenhouses": [
          {
            x: "62.2051%",
            y: "19.7031%",
            handle: "vego-garden-pacific-greenhouse",
          },
        ],
        "vego-garden-pacific-greenhouse": {
          desktop: [
            {
              x: "20.2051%",
              y: "42.7031%",
              handle: "vego-garden-pacific-greenhouse",
            },
          ],
          mobile: [
            {
              x: "24.2051%",
              y: "32.7031%",
              handle: "vego-garden-pacific-greenhouse",
            },
          ],
        },
        "retractable-hose-reel-set-130": [
          {
            x: "40.2051%",
            y: "44.7031%",
            handle: "retractable-hose-reel-set-130",
          },
        ],
        // Father's Day Collection END
        "self-watering-planters-1": {
          desktop: [
            {
              x: "23.5772%",
              y: "68.5811%",
              handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
            },
            {
              x: "51.8293%",
              y: "54.7297%",
              handle: "ez-self-watering-herb-planter-with-trellis-g2",
            },
            {
              x: "71.1382%",
              y: "45.6081%",
              handle: "self-watering-mini-planter-pot-with-trellis",
            },
          ],
          mobile: [
            {
              x: "23.5772%",
              y: "68.5811%",
              handle: "self-watering-rolling-tomato-planter-pot-with-trellis",
            },
            {
              x: "52.0896%",
              y: "50.1688%",
              handle: "ez-self-watering-herb-planter-with-trellis-g2",
            },
            {
              x: "70.2985%",
              y: "36.6667%",
              handle: "self-watering-mini-planter-pot-with-trellis",
            },
          ],
        },
      };
      let greenhousePLPConfig = {
        // Father's Day Collection END
        "greenhouse-hanging-kit": {
          desktop: [
            {
              x: "10.5772%",
              y: "7.0811%",
              handle: "greenhouse-hanging-kit",
            },
          ],
          mobile: [
            {
              x: "23.5772%",
              y: "68.5811%",
              handle: "greenhouse-hanging-kit",
            },
          ],
        },
        "foldable-shelf": {
          desktop: [
            {
              x: "43.5772%",
              y: "34.0811%",
              handle: "foldable-shelf",
            },
          ],
          mobile: [
            {
              x: "43.5772%",
              y: "29.5811%",
              handle: "6-pot-holder-set-of-3",
            },
          ],
        },
        "fixed-bottom-shelf": {
          desktop: [
            {
              x: "37.5772%",
              y: "60.0811%",
              handle: "fixed-bottom-shelf",
            },
          ],
          mobile: [
            {
              x: "25.5772%",
              y: "49.5811%",
              handle: "fixed-bottom-shelf",
            },
          ],
        },
        "the-ezcube-planter-21-x-24_2": [
          {
            x: "33.5772%",
            y: "34.0811%",
            handle: "foldable-shelf",
          },
        ],
        "greenhouse-hanging-kit_mobile": [
          {
            x: "18.5772%",
            y: "23.0811%",
            handle: "greenhouse-hanging-kit",
          },
        ],
        "a_6-pot-holder-set-of-3": {
          desktop: [
            {
              x: "33.5772%",
              y: "42.0811%",
              handle: "6-pot-holder-set-of-3",
            },
          ],
          mobile: [
            {
              x: "23.5772%",
              y: "68.5811%",
              handle: "6-pot-holder-set-of-3",
            },
          ],
        },
      };
      let greenhouseAddOnsPLPConfig = {
        'fixed-top-shelf-item-1':{
           desktop: [
            {
              x: "80.5772%",
              y: "72.0811%",
              handle: "fixed-top-shelf",
            },
          ],
          mobile: [
            {
              x: "80.5772%",
              y: "72.0811%",
              handle: "fixed-top-shelf",
            },
          ],
        },
        'fixed-bottom-shelf-item-2':{
           desktop: [
            {
              x: "31.5772%",
              y: "72.0811%",
              handle: "fixed-bottom-shelf",
            },
          ],
          mobile: [
            {
              x: "23.5772%",
              y: "68.5811%",
              handle: "fixed-bottom-shelf",
            },
          ]
        },
        'fixed-bottom-shelf-item-mob':{
           desktop: [
            {
              x: "31.5772%",
              y: "72.0811%",
              handle: "fixed-bottom-shelf",
            },
          ],
          mobile: [
            {
             x: "17.5772%",
              y: "84.0811%",
              handle: "fixed-bottom-shelf",
            },
          ]
        },
        '6-pot-holder-set-of-3-item-1':{
           desktop: [
            {
              x: "64.5772%",
              y: "48.0811%",
              handle: "6-pot-holder-set-of-3",
            },
          ],
          mobile: [
            {
             x: "64.5772%",
              y: "47.0811%",
              handle: "6-pot-holder-set-of-3",
            },
          ]
        }
      }
      if (location.pathname.includes("/vego-garden-victorian-greenhouse-12-5-ft")) {
        //  hightConfig = {
        //    "v-125-02-1": {
        //      mobile: [],
        //      desktop: [
        //        {
        //          x: "48.5051%",
        //          y: "40.7031%",
        //          handle: "auto-vent-opener-2-pack",
        //        },
        //      ],
        //    },

        //    "v-125-1-1": {
        //      desktop: [],
        //      mobile: [
        //        {
        //          x: "48.5051%",
        //          y: "40.7031%",
        //          handle: "auto-vent-opener-2-pack",
        //        },
        //      ],
        //    },
        //    "v-125-1": {
        //      mobile: [],
        //      desktop: [
        //        {
        //          x: "40.5051%",
        //          y: "48.7031%",
        //          handle: "auto-vent-opener-2-pack",
        //        },
        //      ],
        //    },
        //    "v-125-2-1": {
        //      desktop: [],
        //      mobile: [
        //        {
        //          x: "83.5051%",
        //          y: "47.7031%",
        //          handle: "fixed-top-shelf",
        //        },
        //        {
        //          x: "66.5051%",
        //          y: "72.7031%",
        //          handle: "fixed-bottom-shelf",
        //        },
        //      ],
        //    },
        //    "v-125-2": {
        //      mobile: [],
        //      desktop: [
        //        {
        //          x: "80.5051%",
        //          y: "42.7031%",
        //          handle: "fixed-top-shelf",
        //        },
        //        {
        //          x: "59.5051%",
        //          y: "72.7031%",
        //          handle: "fixed-bottom-shelf",
        //        },
        //      ],
        //    },
        //    "v-125-3": {
        //      mobile: [],
        //      desktop: [
        //        {
        //          x: "42.5051%",
        //          y: "40.7031%",
        //          handle: "the-grow-light-garden-series-f4s-pro",
        //        },
        //        {
        //          x: "44.5051%",
        //          y: "57.7031%",
        //          handle: "ez-self-watering-herb-planter-with-trellis-g2",
        //        },
        //        {
        //          x: "52.5051%",
        //          y: "58.7031%",
        //          handle: "vego-1020-stackable-seedling-tray",
        //        },
        //      ],
        //    },
        //    "v-125-3-1": {
        //      desktop: [],
        //      mobile: [
        //        {
        //          x: "42.5051%",
        //          y: "36.7031%",
        //          handle: "the-grow-light-garden-series-f4s-pro",
        //        },
        //        {
        //          x: "41.5051%",
        //          y: "54.7031%",
        //          handle: "ez-self-watering-herb-planter-with-trellis-g2",
        //        },
        //        {
        //          x: "50.5051%",
        //          y: "48.7031%",
        //          handle: "vego-1020-stackable-seedling-tray",
        //        },
        //      ],
        //    },
        //  };

      }else if (location.pathname.includes("/vego-garden-junior-victoria-greenhouse-8-0-ft")) {
        hightConfig = {
          "jv-80-3-1": {
            mobile: [
              {
                x: "76.5051%",
                y: "58.7031%",
                handle: "vego-garden-tool-box",
              },
            ],
            desktop: [],
          },
          "jv-80-3": {
            desktop: [
              {
                x: "76.5051%",
                y: "61.7031%",
                handle: "vego-garden-tool-box",
              },
            ],
            mobile: [],
          },
          "jv-80-2": {
            desktop: [
              {
                x: "41.5051%",
                y: "51.9031%",
                handle: "the-grow-light-garden-series-f4s",
              },
              {
                x: "38.5051%",
                y: "87.7031%",
                handle: "giga-seedling-tray",
              },
            ],
            mobile: [],
          },
          "jv-80-1-1": {
            desktop: [],
            mobile: [
              {
                x: "40.5051%",
                y: "53.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
          "jv-80-1": {
            desktop: [
              {
                x: "33.5051%",
                y: "53.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            mobile: [
              {
                x: "46.5051%",
                y: "51.9031%",
                handle: "the-grow-light-garden-series-f4s",
              },
              {
                x: "38.5051%",
                y: "83.7031%",
                handle: "giga-seedling-tray",
              },
            ],
          },
        };
      } else if (
        location.pathname.includes(
          "/vego-garden-junior-victorian-greenhouse-6-5-ft"
        )
      ) {
        hightConfig = {
          "jv-65-1-1": {
            desktop: [],
            mobile: [
              {
                x: "39.5051%",
                y: "40.9031%",
                handle: "the-grow-light-garden-series-f4",
              },
              {
                x: "38.5051%",
                y: "54.7031%",
                handle: "giga-seedling-tray",
              },
              {
                x: "39.5051%",
                y: "61.7031%",
                handle: "vego-1020-stackable-seedling-tray",
              },
              {
                x: "62.5051%",
                y: "62.7031%",
                handle: "the-ezcube-planter-21-x-24",
              },
              {
                x: "75.5051%",
                y: "77.7031%",
                handle: "ez-home-planter",
              },
            ],
          },
          "jv-65-1": {
            mobile: [],
            desktop: [
              {
                x: "41.5051%",
                y: "40.9031%",
                handle: "the-grow-light-garden-series-f4",
              },
              {
                x: "38.5051%",
                y: "54.7031%",
                handle: "giga-seedling-tray",
              },
              {
                x: "39.5051%",
                y: "61.7031%",
                handle: "vego-1020-stackable-seedling-tray",
              },
              {
                x: "62.5051%",
                y: "62.7031%",
                handle: "the-ezcube-planter-21-x-24",
              },
              {
                x: "75.5051%",
                y: "77.7031%",
                handle: "ez-home-planter",
              },
            ],
          },
          "jv-65-2-1": {
            desktop: [],
            mobile: [
              {
                x: "39.5051%",
                y: "53.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
          "jv-65-2": {
            mobile: [],
            desktop: [
              {
                x: "33.5051%",
                y: "53.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
        };
      }if (
        location.pathname.includes("/vego-garden-victorian-greenhouse-10-5-ft")
      ) {
        hightConfig = {
          "v-105-02-1": {
            desktop: [
              {
                x: "72.5051%",
                y: "87.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              },
            ],
            mobile: [],
          },
          "v-105-02-2-1": {
            mobile: [
              {
                x: "38.5051%",
                y: "24.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            desktop: [],
          },
          "v-105-02-2": {
            desktop: [
              {
                x: "38.5051%",
                y: "43.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            mobile: [
              {
                x: "57.5051%",
                y: "78.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              },
            ],
          },
          "v-105-02-3": {
            desktop: [
              {
                x: "45.5051%",
                y: "71.7031%",
                handle: "giga-seedling-tray",
              },
            ],
            mobile: [],
          },
          "v-105-02-3-1": {
            mobile: [
              {
                x: "45.5051%",
                y: "68.7031%",
                handle: "giga-seedling-tray",
              },
            ],
            desktop: [],
          },
          "v-105-02-4": {
            desktop: [
              {
                x: "38.5051%",
                y: "7.7031%",
                handle: "the-grow-light-garden-series-f4s-pro",
              },
              {
                x: "10.5051%",
                y: "74.7031%",
                handle: "the-ezcube-planter-21-x-24",
              },
              {
                x: "63.5051%",
                y: "58.7031%",
                handle: "ez-self-watering-herb-planter-with-trellis-g2",
              },
            ],
            mobile: [],
          },
          "v-105-02-4-1": {
            mobile: [
              {
                x: "38.5051%",
                y: "2.7031%",
                handle: "the-grow-light-garden-series-f4s-pro",
              },
              {
                x: "10.5051%",
                y: "74.7031%",
                handle: "the-ezcube-planter-21-x-24",
              },
              {
                x: "59.5051%",
                y: "52.7031%",
                handle: "ez-self-watering-herb-planter-with-trellis-g2",
              },
            ],
            desktop: [],
          },
          "v-105-02-5": {
            desktop: [
              {
                x: "14.5051%",
                y: "32.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
            mobile: [],
          },
          "v-105-02-5-1": {
            mobile: [
              {
                x: "14.5051%",
                y: "25.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
            desktop: [],
          },
          "v-105-4-1": {
            mobile: [
              {
                x: "22.5051%",
                y: "43.7031%",
                handle: "fixed-top-shelf",
              },
              {
                x: "24.5051%",
                y: "57.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
            desktop: [],
          },
          "v-105-4": {
            mobile: [],
            desktop: [
              {
                x: "25.5051%",
                y: "46.7031%",
                handle: "fixed-top-shelf",
              },
              {
                x: "28.5051%",
                y: "57.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
          },
          "v-105-3-1": {
            mobile: [
              {
                x: "31.5051%",
                y: "32.7031%",
                handle: "the-grow-light-garden-series-f4s-pro",
              },
              {
                x: "38.5051%",
                y: "51.7031%",
                handle: "giga-seedling-tray",
              },
            ],
            desktop: [],
          },
          "v-105-3": {
            mobile: [],
            desktop: [
              {
                x: "31.5051%",
                y: "35.7031%",
                handle: "the-grow-light-garden-series-f4s-pro",
              },
              {
                x: "38.5051%",
                y: "54.7031%",
                handle: "giga-seedling-tray",
              },
            ],
          },
          "v-105-2-1": {
            mobile: [
              {
                x: "44.5051%",
                y: "35.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            desktop: [],
          },
          "v-105-2": {
            mobile: [
              {
                x: "58.5051%",
                y: "74.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              },
            ],
            desktop: [
              {
                x: "41.5051%",
                y: "53.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
          "v-105-1": {
            desktop: [
              {
                x: "72.5051%",
                y: "82.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              },
            ],
            mobile: [],
          },
        };
      } else if (
        location.pathname.includes("/vego-garden-victorian-greenhouse-85-ft")
      ) {
        hightConfig = {
          "v-85-02-4": {
            mobile: [],
            desktop: [
              {
                x: "18.5051%",
                y: "32.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
          },
          "v-85-02-5": {
            mobile: [],
            desktop: [
              {
                x: "2.5051%",
                y: "66.7031%",
                handle: "seedling-trays",
              },
            ],
          },
          "v-85-02-3": {
            mobile: [],
            desktop: [
             {
                x: "57.5051%",
                y: "85.7031%",
                handle: "the-ezcube-self-watering-planter-21-x-24-elevated-sage-green",
              },
            ],
          },
          "v-85-02-6": {
            mobile: [],
            desktop: [
              {
                x: "8.5051%",
                y: "58.7031%",
                handle: "flower-cage-round-2-pack",
              },
                {
                x: "62.5051%",
                y: "61.7031%",
                handle: "9-in-1-modular-raised-garden-bed",
              },
              {
                x: "86.5051%",
                y: "78.7031%",
                handle: "17-tall-modern-raised-garden-bed-2753",
              },
               {
                x: "92.5051%",
                y: "10.7031%",
                handle: "birdcage-trellis-2-pack",
              },
            ],
          },
          "v-85-02-6-1":{
            desktop: [],
            mobile: [
              {
                x: "2.5051%",
                y: "58.7031%",
                handle: "flower-cage-round-2-pack",
              },
                {
                x: "62.5051%",
                y: "61.7031%",
                handle: "9-in-1-modular-raised-garden-bed",
              },
              {
                x: "86.5051%",
                y: "78.7031%",
                handle: "17-tall-modern-raised-garden-bed-2753",
              }
              ,
               {
                x: "90.5051%",
                y: "10.7031%",
                handle: "birdcage-trellis-2-pack",
              },
            ],
          },
          "v-85-02-2-1": {
            desktop: [],
            mobile: [
              {
                x: "29.5051%",
                y: "-6%",
                handle: "greenhouse-hanging-kit",
              },
            ],
          },
          "v-85-02-2": {
            mobile: [
              {
                x: "50.5051%",
                y: "61.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            desktop: [
              {
                x: "34.5051%",
                y: "0.7031%",
                handle: "greenhouse-hanging-kit",
              },
            ],
          },
          "v-85-02-1-1": {
            desktop: [],
            mobile: [
              {
                x: "-4.5051%",
                y: "61.7031%",
                handle: "seedling-trays",
              },
            ],
          },
          "v-85-02-1": {
            mobile: [
              {
                x: "56.5051%",
                y: "81.7031%",
                handle: "the-ezcube-self-watering-planter-21-x-24-elevated-sage-green",
              },
            ],
            desktop: [
              {
                x: "52.5051%",
                y: "55.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },

          "v-85-1": {
            desktop: [
              {
                x: "30.5051%",
                y: "41.7031%",
                handle: "ultimate-grow-light-garden-with-storage",
              }
            ],
            mobile: [],
          },
          "v-85-1-1":{
            mobile: [
              {
                x: "24.5051%",
                y: "42.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              }
            ],
            desktop: [
              
            ],
          },
          "v-85-2-1": {
            desktop: [
              {
                x: "24.5051%",
                y: "60.7031%",
                handle: "elevated-garden-bed-v-series-2-x-4-with-wheels",
              },
               {
                x: "65.5051%",
                y: "14.7031%",
                handle: "foldable-shelf",
              },
            ],
            mobile: [
              {
                x: "52.5051%",
                y: "55.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
          "v-85-2": {
            desktop: [
              {
                x: "52.5051%",
                y: "55.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            mobile: [
              {
                x: "25.5051%",
                y: "40.7031%",
                handle: "ultimate-grow-light-garden-with-storage",
              }
              
            ],
          },
          "v-85-3-1": {
            desktop: [],
            mobile: [
              {
                x: "83.5051%",
                y: "45.7031%",
                handle: "fixed-top-shelf",
              },
              {
                x: "66.5051%",
                y: "70.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
          },
          "v-85-3": {
            mobile: [],
            desktop: [
              {
                x: "78.5051%",
                y: "42.7031%",
                handle: "fixed-top-shelf",
              },
              {
                x: "53.5051%",
                y: "70.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
          },
          "v-85-4": {
            mobile: [],
            desktop: [
              {
                x: "8.5051%",
                y: "64.7031%",
                handle: "flower-cage-round-2-pack",
              },
                {
                x: "62.5051%",
                y: "66.7031%",
                handle: "9-in-1-modular-raised-garden-bed",
              },
              {
                x: "86.5051%",
                y: "84.7031%",
                handle: "17-tall-modern-raised-garden-bed-2753",
              },
              {
                x: "92.5051%",
                y: "17.7031%",
                handle: "birdcage-trellis-2-pack",
              },
            ],
          },
          "v-85-4-1": {
            desktop: [],
            mobile: [
              {
                x: "9.5051%",
                y: "58.7031%",
                handle: "flower-cage-round-2-pack",
              },
                {
                x: "62.5051%",
                y: "56.7031%",
                handle: "9-in-1-modular-raised-garden-bed",
              },
              {
                x: "86.5051%",
                y: "74.7031%",
                handle: "17-tall-modern-raised-garden-bed-2753",
              },
              {
                x: "90.5051%",
                y: "9.7031%",
                handle: "birdcage-trellis-2-pack",
              }
            ],
          },
        };
      } else if (
        location.pathname.includes("/vego-garden-pacific-greenhouse-10-5-ft")
      ) {
        hightConfig = {
          "combine-3": {
            mobile: [
              {
                x: "54.5051%",
                y: "41.7031%",
                handle: "fixed-top-shelf",
              },
            ],
            desktop: [
              {
                x: "8.5051%",
                y: "46.7031%",
                handle: "fixed-top-shelf",
              },
            ],
          },
          "combine-2-1": {
            desktop: [],
            mobile: [
              {
                x: "40.5051%",
                y: "46.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
          },
          "combine-5-1": {
            desktop: [],
            mobile: [
              {
                x: "51.5051%",
                y: "44.7031%",
                handle: "fixed-top-shelf",
              },
              {
                x: "49.5051%",
                y: "55.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
          },
          "combine-2": {
            desktop: [
              {
                x: "42.5051%",
                y: "35.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            mobile: [
              {
                x: "35.5051%",
                y: "51.7031%",
                handle: "the-grow-light-garden-series-f4",
              },
            ],
          },
          "combine-1": {
            desktop: [
              {
                x: "42.5051%",
                y: "57.7031%",
                handle: "the-grow-light-garden-series-f4",
              },
            ],
            mobile: [
              {
                x: "63.5051%",
                y: "35.7031%",
                handle: "the-grow-light-garden-series-f4",
              },
            ],
          },
          "grow-light-m": {
            desktop: [
              {
                x: "42.5051%",
                y: "55.7031%",
                handle: "fixed-bottom-shelf",
              },
            ],
            mobile: [],
          },
        };
      // } else if (
      //   location.pathname.includes("/vego-garden-pacific-greenhouse-12-5-ft")
      // ) {
      //   hightConfig = {
      //     "grow-light-m": {
      //       mobile: [
      //         {
      //           x: "63.5051%",
      //           y: "35.7031%",
      //           handle: "the-grow-light-garden-series-f4s-pro",
      //         },
      //       ],
      //       desktop: [],
      //     },
      //     "grow-light": {
      //       desktop: [
      //         {
      //           x: "71.5051%",
      //           y: "41.7031%",
      //           handle: "the-grow-light-garden-series-f4s-pro",
      //         },
      //       ],
      //       mobile: [],
      //     },
      //     combine2: {
      //       desktop: [],
      //       mobile: [
      //         {
      //           x: "38.5051%",
      //           y: "40.7031%",
      //           handle: "6-pot-holder-set-of-3",
      //         },
      //         {
      //           x: "54.5051%",
      //           y: "41.7031%",
      //           handle: "fixed-top-shelf",
      //         },
      //         {
      //           x: "51.5051%",
      //           y: "55.7031%",
      //           handle: "fixed-bottom-shelf",
      //         },
      //       ],
      //     },
      //     "pacific-125-combine": {
      //       desktop: [
      //         {
      //           x: "41.5051%",
      //           y: "40.7031%",
      //           handle: "6-pot-holder-set-of-3",
      //         },
      //         {
      //           x: "57.5051%",
      //           y: "42.7031%",
      //           handle: "fixed-top-shelf",
      //         },
      //         {
      //           x: "51.5051%",
      //           y: "57.7031%",
      //           handle: "fixed-bottom-shelf",
      //         },
      //       ],
      //       mobile: [],
      //     },
      //   };
      } else if (
        location.pathname.includes("/vego-garden-pacific-greenhouse")
      ) {
        hightConfig = {
          "p-85-4-1": {
            mobile: [
              {
                x: "47.5051%",
                y: "40.7031%",
                handle: "seedling-trays",
              },
              {
                x: "36.5051%",
                y: "62.7031%",
                handle: "jumbo-seedling-trays",
              },
            ],
            desktop: [],
          },
          "p-85-4": {
            desktop: [
              {
                x: "47.5051%",
                y: "45.7031%",
                handle: "seedling-trays",
              },
              {
                x: "38.5051%",
                y: "67.7031%",
                handle: "jumbo-seedling-trays",
              },
            ],
            mobile: [],
          },
          "p-85-3-1": {
            mobile: [
              {
                x: "1.5051%",
                y: "63.7031%",
                handle: "seedling-trays",
              },
            ],
            desktop: [],
          },
          "p-85-3": {
            desktop: [
              {
                x: "1.5051%",
                y: "66.7031%",
                handle: "seedling-trays",
              },
            ],
            mobile: [],
          },
          "p-85-2-1": {
            mobile: [
              {
                x: "34.5051%",
                y: "44.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            desktop: [],
          },
          "p-85-2": {
            desktop: [
              {
                x: "34.5051%",
                y: "55.7031%",
                handle: "auto-vent-opener-2-pack",
              },
            ],
            mobile: [
              {
                x: "34.5051%",
                y: "51.7031%",
                handle: "vego-garden-tool-box",
              },
            ],
          },
          "p-85-1": {
            desktop: [
              {
                x: "34.5051%",
                y: "61.7031%",
                handle: "vego-garden-tool-box",
              },
            ],
            mobile: [],
          },
        };
      } else if (location.pathname.includes("/on-sale-fathers-day")) {
        hightConfig = {
          ...father_day_v2026_config,
          // ...vego_day_config,
        };
      } else if (location.pathname.includes("/vego-garden-mothers-day")) {
        hightConfig = {
          ...mother_day_v2026_config,
          // ...vego_day_config,
        };
      } else if (location.pathname.includes("/greenhouses")) {
        hightConfig = {
          ...greenhousePLPConfig,
          // ...vego_day_config,
        };
      } else if (location.pathname.includes("/vego-day-landing-page")) {
        hightConfig = {
          ...hightConfig,
          // ...vego_day_config,
        };
      } else if (location.pathname.includes("/pages/sustainability")) {
        hightConfig = {
          "grow-light-m": {
            desktop: [
              {
                x: "51.5051%",
                y: "61.7031%",
                handle: "ezcube-elevated-rolling-planter-21-x-48",
              },
            ],
            mobile: [
              {
                x: "51.5051%",
                y: "53.7031%",
                handle: "ezcube-elevated-rolling-planter-21-x-48",
              },
            ],
          },
          "grow-light-m-2": {
            desktop: [
              {
                x: "58.5051%",
                y: "61.7031%",
                handle: "worm-farm-worm-composter",
              },
            ],
            mobile: [
              {
                x: "58.5051%",
                y: "61.7031%",
                handle: "worm-farm-worm-composter",
              },
            ],
          },
          "grow-light-m-3": {
            desktop: [
              {
                x: "52.5051%",
                y: "66.7031%",
                handle: "kitchen-composter",
              },
            ],
            mobile: [
              {
                x: "52.5051%",
                y: "66.7031%",
                handle: "kitchen-composter",
              },
            ],
          },
        };
      } else if (location.pathname.includes("/greenhouse-add-ons")) {
        hightConfig = {
          ...greenhouseAddOnsPLPConfig,
        };
      } else if (location.pathname.includes("/garden-workstation-cabinet")) {
        hightConfig = {
          "relative-container": {
            mobile: [
              {
                x: "8.5051%",
                y: "35.2031%",
                handle: "hanging-rack-shelf-set",
              },
              {
                x: "11.5051%",
                y: "51.2031%",
                handle: "potting-bench-hanging-rack",
              },
              {
                x: "45.5051%",
                y: "40.7031%",
                handle: "self-watering-mini-planter-pot-with-trellis",
              },
              {
                x: "42.5051%",
                y: "61.7031%",
                handle: "jumbo-1020-up-pot-cell-bundle",
              },
              {
                x: "35.5051%",
                y: "51.7031%",
                handle: "jumbo-1020-up-pot-cell-bundle",
              },
            ],
            desktop: [
              {
                x: "12.5051%",
                y: "14.2031%",
                handle: "hanging-rack-shelf-set",
              },
              {
                x: "30.5051%",
                y: "14.2031%",
                handle: "potting-bench-hanging-rack",
              },
              {
                x: "57.5051%",
                y: "27.7031%",
                handle: "self-watering-mini-planter-pot-with-trellis",
              },
              { x: "25.5051%", y: "44.7031%", handle: "garden-sink-station" },
              { x: "47.5051%", y: "44.7031%", handle: "garden-workstation" },
              {
                x: "54.5051%",
                y: "58.7031%",
                handle: "jumbo-1020-up-pot-cell-bundle",
              },
            ],
          },
        };
      }
      if (location.pathname == '/') {
        hightConfig = {
          ...hightConfig,
          ...home_v2025_config
        }
      }


      window.initPointHights = function (config) {
        const pointTemplate = `
            <a class="why-dot-circle point-highlight" data-target="#product-highlight-tooltip">
              <span class="why-dot" for="Safety Features"> </span>
            </a>
        `
        for (const key in config) {
          let configItem = config[key]
          let points
          if (configItem.desktop && !theme.isMobile()) {
            points = configItem.desktop
          } else if (configItem.mobile && theme.isMobile()) {
            points = configItem.mobile
          } else {
            points = configItem
          }
          for (const point of points) {
            const pointDom = $(pointTemplate)
            pointDom.css('left', point.x)
            pointDom.css('top', point.y)
            pointDom.data('handle', point.handle)
            if(!theme.isMobile()&&location.pathname == '/') {
              pointDom.attr('href','/products/' + point.handle)
            }
            $('#' + key).append(pointDom)
          }
        }
      }

      window.initPointHights(hightConfig);
      var $hightlightTarget
      var activePoperInstance
      function showHighlight($ele) {
        if ($ele.hasClass('show')) {
          return false
        }
        $ele.addClass('show')
        $ele.addClass('animating')
      }
      function hideHighlight($ele) {
        if (!$ele.hasClass('show')) {
          return false
        }
        $ele.removeClass('animating')
        setTimeout(() => {
          $ele.removeClass('show')
          if (activePoperInstance) {
            activePoperInstance.destroy()
            activePoperInstance = null
          }
        }, 300)
      }
      function stripHtmlTags(html) {
        return (html ?? '').replace(/<[^>]*>/g, '');
      }
      window.hightlightPotEvent = ()=>{
        $(".point-highlight").each(function () {
          var target = $(this).data("target");
          if (target && $(target).length) {
            var _this = this;
            var $target = $(target);
            $hightlightTarget = $target;
            var inTarget = false;
            $(this).on("mouseover touchstart", function () {
              if ($(this).data("handle")) {
                const tooltip = $($(this).data("target"));
                const handle = $(this).data("handle");
                if (tooltip.data("handle") !== handle) {
                  const productEle = $(
                    ".grid-product[data-product-handle=" + handle + "]",
                  ).first();
                  if (productEle.length) {
                    const srcset = productEle
                      .find(".grid__image-ratio > img")
                      .attr("srcset");
                    const src = srcset.split(",")[0].split(" ")[0];
                    const image = new Image();
                    image.src = src;
                    image.onload = () => {
                      tooltip.find(".tooltip-head").html(image);
                    };
                    tooltip.find(".tooltip-head > img").css("opacity", 0);
                    tooltip
                      .find(".tooltip-title")
                      .html(productEle.find(".grid-product__title").text());
                    const desc = productEle
                      .closest(".flickity-item")
                      .find(".product-description")
                      .val();
                    tooltip.find(".tooltip-desc").html(stripHtmlTags(desc));
                    if (theme.isCA()) {
                      tooltip
                        .find("a")
                        .attr("href", `/en-ca/products/${handle}`);
                    } else {
                      tooltip.find("a").attr("href", `/products/${handle}`);
                    }
                    tooltip.data("handle", handle);
                  }
                }
              }
              showHighlight($target);
              var popperInstance = Popper.createPopper(_this, $target[0], {
                strategy: "fixed",
                placement: theme.isMobile() ? "bottom" : "left",
                modifiers: theme.isMobile()
                  ? [
                      {
                        name: "offset",
                        options: {
                          offset: [-20, 0],
                        },
                      },
                    ]
                  : [],
              });
              popperInstance.update();
              activePoperInstance = popperInstance;
            });
            if (!theme.isMobile()) {
              $(this).on("mouseleave", function (e) {
                setTimeout(() => {
                  if (!inTarget) {
                    hideHighlight($target);
                  }
                }, 100);
              });
              $target.on("mouseover", function (e) {
                inTarget = true;
              });
              $target.on("mouseleave", function (e) {
                inTarget = false;
                hideHighlight($target);
              });
            }
          }
        });
      }
      window.hightlightPotEvent()
      if ($('.point-highlight').length) {
        if (theme.isMobile()) {
          $(document.body).on('touchstart', function (e) {
            if ($(e.target).closest('.point-highlight').length || $(e.target).closest('.highlight-tooltip').length) {
              return
            }
            if ($hightlightTarget) {
              hideHighlight($hightlightTarget)
            }
          })
        }
      }
      $('body').on('click', function (e) {
        $('[data-popover]').each(function () {
          var target = $('#' + this.dataset.popover)
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && target.has(e.target).length === 0) {
            target.removeClass('show')
          }
        });
      });
      if (theme.isMobile()) {
        $('.des-table:visible').each(function () {
          if ($(this).height() > 285) {
            $(this).addClass('collapse')
          }
          $(this).on('click', '.collapse-drop', e => {
            $(this).removeClass('collapse')
            $(e.currentTarget).remove()
          })
        })
      }
      var reviewText = $('#yotpo-hidden-reviews').val()
      var schema = []
      if (reviewText) {
        var regex1 = /Review by ([\w\s\.]+?) on ([\w\s]+)/g
        var $title = $(reviewText).find('.content-title')
        var reviews = $(reviewText).find('.yotpo-review-wrapper')
        reviews.each(function (i) {
          var children = $(this).children()
          if (children.length) {
            var text = $(children.get(0)).text()
            var one = {
              "author": "John Doe",
              "datePublished": "Unknown",
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "bestRating": "5",
                "ratingValue": "5",
                "worstRating": "1"
              }
            }
            var match
            while ((match = regex1.exec(text)) != null) {
              one.author = match[1]
              one.datePublished = ts2shortDateFormat(new Date(match[2]))
            }
            one.name = $($title.get(i)).text()
            one.reviewBody = $(children.get(2)).text()
            schema.push(one)
          }
        })
        if (schema.length) {
          var json = JSON.parse($('#product-ld-schema').text())
          $('#product-ld-schema').remove()
          json.review = schema
          var b = document.createElement('script')
          b.type = "application/ld+json"
          b.innerHTML = JSON.stringify(json)
          document.getElementsByTagName("head")[0].appendChild(b)
        }
      }
      if (theme.isMobile()) {
        $('.timeline').textFolder({
          height: 500,
          btnDown: $('.timeline .read-more'),
          btnUp: $('.timeline .read-less'),
          restore: true
        })
      }
      if ($('.hc-size-option .step-slider').length) {
        var sizeOption = {}
        function appendSizeQuery(name, values) {
          var qstr = ''
          var i = +values[0]
          for (var i = +values[0]; i <= +values[1]; i = i + 0.5) {
            qstr += name + '=' + i.toFixed(1) + '&'
          }
          sizeOption[name] = qstr
        }
        function buildQuery() {
          var query = $.qs()
          var qstr = ''
          for (var k in query) {
            qstr += k + '=' + encodeURIComponent(query[k]) + '&'
          }
          for (var k in sizeOption) {
            qstr += sizeOption[k]
          }
          $('.hc-size-option .btn').attr('href', Shopify.routes.root + 'collections/all?' + qstr.substring(0, qstr.length - 1))
        }
        $('.hc-size-option .step-slider').each(function () {
          var min = +$(this).data('min')
          var max = +$(this).data('max')
          var step = +$(this).data('step')
          var name = $(this).data('name')
          var start = min,
            end = max
          noUiSlider.create(this, {
            start: [start, end],
            step: step,
            connect: true,
            range: {
              min: min,
              max: max,
            },
          })
          this.noUiSlider.on('change', function (values, handleNumber, unencoded) {
            appendSizeQuery(name, values)
            buildQuery()
          })
          appendSizeQuery(name, this.noUiSlider.get())
        })
        buildQuery()
      }
      sectionFade.init()
      saleSpy.init($('.sale-sidebar-menu > li'))

      if (!theme.isMobile()) {
        if ($('.related-categories-flickity-pc').length) {
          const $prev = $(`<button type="button" class="flickity-button flickity-prev-next-button previous" role="button"><span class="sr-only">previous</span><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><rect width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"></path></svg></button>`)
          const $next = $(`<button type="button" class="flickity-button flickity-prev-next-button next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><rect width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" fill="#3A5B39"/><<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"></path></svg></button>`)
          const flickity = new Flickity($('.related-categories-flickity-pc')[0], {
            adaptiveHeight: false,
            autoPlay: false,
            avoidReflow: false, // custom by Archetype
            childNav: null, // element. Custom by Archetype instead of asNavFor
            childNavScroller: null, // element
            childVertical: false,
            fade: false,
            initialIndex: 0,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
            rightToLeft: theme.config.rtl,
            setGallerySize: true,
            wrapAround: true,
            cellAlign: 'left'
          })
          $('.related-categories-section').append($prev)
          $('.related-categories-section').append($next)
          flickity.resize();
          flickity.reposition();

          $prev.on(
            "click",
            function () {
              flickity.previous()
            }
          );
          $next.on(
            "click",
            function () {
              flickity.next()
            }
          );
        }
      }
    })
  })()

